import React, { Component } from 'react'

import { Switch, Spin, Tooltip, Modal, button, Popconfirm, Tabs, Select, Input, } from 'antd';
import moment from 'moment';
import { DeleteOutlined, QuestionCircleOutlined, } from '@ant-design/icons';
import Select2multiple from '../../../components/FormComponent/select2/multiple';
import Select2 from '../../../components/FormComponent/select2';
import { formDataSchema, smsformDataSchema, icuDataSchema, emailDataSchema, breaksDataSchema, checklistDataSchema, nmelistDataSchema, checkListAddDataSchema, nmeListAddDataSchema} from '../../../schema/configurations';
import networkList from '../../../constants/networkList';
import postService from '../../../services/httpService';
import Inputlayer from '../../../components/FormComponent/Input';
const $ = require('jquery');
const { Option } = Select;
const { getBreakTimeReasonsList, updateBreakTimeandBreakCount, getFCChecklist, insertMasterNmeList, getMasterNmeList, getMasterNmeListByUnitid, updateMasterNmeList, homepage} = networkList;
class Configuration extends Component {
    constructor(props) {
        super(props)
        this.state = {
            visible: false,
            loadding: false,
            date: new Date(),
            'tbody': [],
            'formData': [],
            'smsformData': [],
            'smsmodal': false,
            'icuformData': [],
            'icumodal': false,
            'emailformData': [],
            'nmelistformData': [],
            'checklistformData': [],
            'emailmodal': false,
            'checklistmodal': false,
            'nmelistmodal': false,
            'title': '',
            duplicateData: [],
            userData: null,
            popUpVisible: false,
            show1: true,
            show2: false,
            show3: false,
            show4: false,
            show5: false,
            show6: false,
            show7: false,
            stationList: [],
            breakModalVisible: false,
            checkModalVisible: false,
            nmeModalVisible: false,
            breaksDetails: null,
            checklistDetails: null,
            nmelistDetails: null,
            textValue:null,
            descriptionValue:null
        }
    }

    componentDidMount() {
        let userData = localStorage.getItem('user_data') && JSON.parse(localStorage.getItem('user_data'));

        this.getconfigurations();
        this.getCounsellingStationsDropDown();
        // this.date();
        let formSchema = Object.assign({}, formDataSchema);
        formSchema['feilds'].map((feild, key) => {
            formSchema['feilds'][key]['value'] = null;
            formSchema['feilds'][key]['valid'] = false;
            formSchema['feilds'][key]['visible'] = true;
            formSchema['feilds'][key]['errors'] = [];
            delete formSchema['feilds'][key]['text'];

        })
        let smsformSchema = Object.assign({}, smsformDataSchema);
        smsformSchema['feilds'].map((feild, key) => {
            smsformSchema['feilds'][key]['value'] = null;
            smsformSchema['feilds'][key]['valid'] = false;
            smsformSchema['feilds'][key]['errors'] = [];
            delete smsformSchema['feilds'][key]['text'];

        })
        let icuformDataSchema = Object.assign({}, icuDataSchema);
        icuformDataSchema['feilds'].map((feild, key) => {
            icuformDataSchema['feilds'][key]['value'] = null;
            icuformDataSchema['feilds'][key]['valid'] = false;
            icuformDataSchema['feilds'][key]['errors'] = [];
            delete icuformDataSchema['feilds'][key]['text'];

        })
        let emailformDataSchema = Object.assign({}, emailDataSchema);
        emailformDataSchema['feilds'].map((feild, key) => {
            if (feild.name === 'multiple_unit') {
                emailformDataSchema['feilds'][key]['value'] = [];
                emailformDataSchema['feilds'][key]['valid'] = false;
                emailformDataSchema['feilds'][key]['errors'] = [];
                emailformDataSchema['feilds'][key]['text'] = 'Select Unit';
            } else {
                emailformDataSchema['feilds'][key]['value'] = null;
                emailformDataSchema['feilds'][key]['valid'] = false;
                emailformDataSchema['feilds'][key]['errors'] = [];
                delete emailformDataSchema['feilds'][key]['text'];
            }


        })

        let checkListAddformDataSchema = Object.assign({}, checkListAddDataSchema);
        checkListAddformDataSchema['feilds'].map((feild, key) => {

            checkListAddformDataSchema['feilds'][key]['value'] = null;
            checkListAddformDataSchema['feilds'][key]['valid'] = false;
            checkListAddformDataSchema['feilds'][key]['errors'] = [];
            delete checkListAddformDataSchema['feilds'][key]['text'];


        })

        let nmeListAddformDataSchema = Object.assign({}, nmeListAddDataSchema);
        nmeListAddformDataSchema['feilds'].map((feild, key) => {
            if (feild.name === 'unit') {
                nmeListAddformDataSchema['feilds'][key]['value'] = [];
                nmeListAddformDataSchema['feilds'][key]['valid'] = false;
                nmeListAddformDataSchema['feilds'][key]['errors'] = [];
                nmeListAddformDataSchema['feilds'][key]['text'] = 'Select Unit';
            } 
            
            else if (feild.name === 'department') {
                nmeListAddformDataSchema['feilds'][key]['value'] = [];
                nmeListAddformDataSchema['feilds'][key]['valid'] = false;
                nmeListAddformDataSchema['feilds'][key]['errors'] = [];
                nmeListAddformDataSchema['feilds'][key]['text'] = 'Select Department';
            } 
            else if (feild.name === 'tariff') {
                nmeListAddformDataSchema['feilds'][key]['value'] = [];
                nmeListAddformDataSchema['feilds'][key]['valid'] = false;
                nmeListAddformDataSchema['feilds'][key]['errors'] = [];
                nmeListAddformDataSchema['feilds'][key]['text'] = 'Select Tariff';
            } 
            else if (feild.name === 'description') {
                nmeListAddformDataSchema['feilds'][key]['value'] = null;
                nmeListAddformDataSchema['feilds'][key]['valid'] = false;
                nmeListAddformDataSchema['feilds'][key]['errors'] = [];
                delete nmeListAddformDataSchema['feilds'][key]['text'];
            } 

            else if (feild.name === 'rate') {
                nmeListAddformDataSchema['feilds'][key]['value'] = null;
                nmeListAddformDataSchema['feilds'][key]['errors'] = [];
            }


        })
        let breaksformDataSchema = Object.assign({}, breaksDataSchema);
        breaksformDataSchema['feilds'].map((feild, key) => {
            breaksformDataSchema['feilds'][key]['value'] = null;
            breaksformDataSchema['feilds'][key]['errors'] = [];
        })
        this.setState({ userData: userData ? userData : null, 'formData': formSchema['feilds'], 'smsformData': smsformSchema['feilds'], 'icuformData': icuformDataSchema['feilds'], 'emailformData': emailformDataSchema['feilds'],'checklistaddformData': checkListAddformDataSchema['feilds'], 'nmelistaddformData': nmeListAddformDataSchema['feilds'],'breaksformData': breaksformDataSchema['feilds'], });

        let checklistformDataSchema = Object.assign({}, checklistDataSchema);
        checklistformDataSchema['feilds'].map((feild, key) => {

            checklistformDataSchema['feilds'][key]['value'] = null;
            checklistformDataSchema['feilds'][key]['errors'] = [];
            delete checklistformDataSchema['feilds'][key]['text'];

        })

        let nmelistformDataSchema = Object.assign({}, nmelistDataSchema);
        nmelistformDataSchema['feilds'].map((feild, key) => {
            if (feild.name === 'unit') {
                nmelistformDataSchema['feilds'][key]['value'] = [];
                nmelistformDataSchema['feilds'][key]['valid'] = false;
                nmelistformDataSchema['feilds'][key]['errors'] = [];
                nmelistformDataSchema['feilds'][key]['text'] = 'Select Unit';
            } 
            
            else if (feild.name === 'department') {
                nmelistformDataSchema['feilds'][key]['value'] = [];
                nmelistformDataSchema['feilds'][key]['valid'] = false;
                nmelistformDataSchema['feilds'][key]['errors'] = [];
                nmelistformDataSchema['feilds'][key]['text'] = 'Select Department';
            } 
            else if (feild.name === 'description') {
                nmelistformDataSchema['feilds'][key]['value'] = null;
                nmelistformDataSchema['feilds'][key]['errors'] = [];
            delete nmelistformDataSchema['feilds'][key]['text'];
            } 
            else if (feild.name === 'tariff') {
                nmelistformDataSchema['feilds'][key]['value'] = [];
                nmelistformDataSchema['feilds'][key]['valid'] = false;
                nmelistformDataSchema['feilds'][key]['errors'] = [];
                nmelistformDataSchema['feilds'][key]['text'] = 'Select Tariff';
            } 

            else if (feild.name === 'rate') {
                nmelistformDataSchema['feilds'][key]['value'] = null;
                nmelistformDataSchema['feilds'][key]['errors'] = [];
            }
        })
        this.setState({ userData: userData ? userData : null, 'formData': formSchema['feilds'], 'smsformData': smsformSchema['feilds'], 'icuformData': icuformDataSchema['feilds'], 'emailformData': emailformDataSchema['feilds'], 'checklistaddformData': checkListAddformDataSchema['feilds'],'nmelistaddformData': nmeListAddformDataSchema['feilds'], 'breaksformData': breaksformDataSchema['feilds'], 'checklistformData': checklistformDataSchema['feilds'], 'nmelistformData': nmelistformDataSchema['feilds']});

    }
    componentWillUnmount() {
        this.setState({
            visible: false,
        });
    }

    // API
    getconfigurations = () => {
        try {
            const { getconfigurations } = networkList;
            const { show1, show2, show3, show4, show6, show7} = this.state
            this.setState((state) => ({ thead: this.state.tableHead, loadding: true }), () => {
                postService(getconfigurations, 'GET', null).then(res => {
                    // console.log('privileges_list:', res.data);
                    if (res.status) {
                        this.setState((state) => ({ duplicateData: res.data, message: '', loadding: false }));
                        if (show1) {
                            const tbodystart = res.data[0].data.filter(eachForm => eachForm.config_type === "counselling")
                            let tbodycounselling = {}
                            for (let each of res.data) {
                                for (let obj in each) {
                                    if (obj === "data") {

                                        tbodycounselling[obj] = tbodystart

                                    } else {
                                        tbodycounselling[obj] = each[obj]
                                    }
                                }
                            }
                            let tbodycounsellingFormData = [tbodycounselling]
                            this.setState({ tbody: tbodycounsellingFormData })
                        } else if (show2) {
                            const tbodystart = res.data[0].data.filter(eachForm => eachForm.config_type === "trackbills")
                            let tbodycounselling = {}
                            for (let each of res.data) {
                                for (let obj in each) {
                                    if (obj === "data") {

                                        tbodycounselling[obj] = tbodystart

                                    } else {
                                        tbodycounselling[obj] = each[obj]
                                    }
                                }
                            }
                            let tbodycounsellingFormData = [tbodycounselling]
                            this.setState({ tbody: tbodycounsellingFormData })
                        } else if (show3) {
                            const tbodystart = res.data[0].data.filter(eachForm => eachForm.config_type === "queue")
                            let tbodycounselling = {}
                            for (let each of res.data) {
                                for (let obj in each) {
                                    if (obj === "data") {

                                        tbodycounselling[obj] = tbodystart

                                    } else {
                                        tbodycounselling[obj] = each[obj]
                                    }
                                }
                            }
                            let tbodycounsellingFormData = [tbodycounselling]
                            this.setState({ tbody: tbodycounsellingFormData })
                        } else if (show4) {
                            const tbodystart = res.data[0].data.filter(eachForm => eachForm.config_type === "text")
                            let tbodycounselling = {}
                            for (let each of res.data) {
                                for (let obj in each) {
                                    if (obj === "data") {

                                        tbodycounselling[obj] = tbodystart

                                    } else {
                                        tbodycounselling[obj] = each[obj]
                                    }
                                }
                            }
                            let tbodycounsellingFormData = [tbodycounselling]
                            this.setState({ tbody: tbodycounsellingFormData })
                        }


                    }
                    else if (show6) {
                        const tbodystart = res.data[0].data.filter(eachForm => eachForm.config_type === "addchecklist")
                        let tbodycounselling = {}
                        for (let each of res.data) {
                            for (let obj in each) {
                                if (obj === "data") {

                                    tbodycounselling[obj] = tbodystart

                                } else {
                                    tbodycounselling[obj] = each[obj]
                                }
                            }
                        }
                        let tbodycounsellingFormData = [tbodycounselling]
                        this.setState({ tbody: tbodycounsellingFormData })
                    }
                    else if (show7) {
                        const tbodystart = res.data[0].data.filter(eachForm => eachForm.config_type === "addnmelist")
                        let tbodycounselling = {}
                        for (let each of res.data) {
                            for (let obj in each) {
                                if (obj === "data") {

                                    tbodycounselling[obj] = tbodystart

                                } else {
                                    tbodycounselling[obj] = each[obj]
                                }
                            }
                        }
                        let tbodycounsellingFormData = [tbodycounselling]
                        this.setState({ tbody: tbodycounsellingFormData })
                    }

                    else {
                        this.setState((state) => ({ message: res.message, loadding: false }));
                        // to catch api errors like --> network,url,outof status 1,0
                        Modal.error({
                            title: 'Failure',
                            content: "Oops! something went wrong... Please try again."
                        });
                    }
                });
            });
        } catch (error) {
            console.log(error);
            Modal.error({
                title: 'Failure',
                content: "Oops, something went wrong... Please try again.",
            });
        }
    }
    updateBilltracking = () => {
        try {
            const { updateConfigBilltrack } = networkList;
            // console.log(this.state.formData)
            const { formData } = this.state
            var formFeilds = formData;
            let errors = this.validateModalFeilds(formFeilds)
            // let data = {
            //     'id': this.state.bill_id,
            //     'bill_tracking_percent': formFeilds[0].value,
            //     'updated_at': this.state.date,
            // }
            // console.log('updateBilltracking data:', data)
            var percent = (formFeilds[0].value);
            if (!errors.includes(false)) {
                // console.clear();
                // console.log('updateBilltracking data:', typeof(percent))

                this.setState((state) => ({ btnloading: true }), () => {
                    postService(updateConfigBilltrack, 'PUT', {
                        "data": {
                            'id': this.state.bill_id,
                            'bill_tracking_percent': percent,
                            'updated_at': this.state.date,
                        }
                    }).then(res => {
                        if (res.status) {
                            // alert('Data inserted');
                            // console.log('res', res)
                            this.setState((state) => ({ btnloading: false, visible: false }));
                            this.getconfigurations();
                            Modal.success({
                                title: 'Success',
                                content: "Successfully Updated",
                            });
                            formData.map((feild, key) => {
                                formData[key]['value'] = null;
                                formData[key]['text'] = null;
                                formData[key]['valid'] = false;
                                formData[key]['visible'] = false;
                            })
                            this.setState({ 'formData': formData });

                        } else {
                            formData.map((feild, key) => {
                                formData[key]['value'] = null;
                                formData[key]['text'] = null;
                                formData[key]['valid'] = false;
                                formData[key]['visible'] = false;
                            })
                            // alert('Data not inserted');
                            this.setState((state) => ({ btnloading: false, visible: false, 'formData': formData }));
                            Modal.error({
                                title: 'Failure',
                                content: "Oops! something went wrong... Please try again.",
                            });

                        }
                    })
                });
                // this.getconfigurations();

                formData.map((feild, key) => {
                    formData[key]['value'] = null;
                    formData[key]['text'] = null;
                    formData[key]['valid'] = false;
                    formData[key]['visible'] = true;
                })
                this.setState({ 'formData': formData });
            }
        } catch (error) {
            Modal.error({
                title: 'Failure',
                content: "Oops, something went wrong... Please try again.",
            });
        }
    }
    // API ending
    date = () => {
        var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        var that = this;
        var date = new Date().getDate(); //Current Date
        var month = monthNames[new Date().getMonth()]; //Current Month
        var year = new Date().getFullYear(); //Current Year

        that.setState({
            //Setting the value of the date time
            date:
                date + ' ' + month + ' ' + year,
        });
    }

    handleChange(ele, event) {
        console.log("handleChange ele", ele);
        // console.log("handleChange feild", event.target.value);
        if (ele) {
            if (ele.name === "emails") {
                let emailformDataSchema = Object.assign({}, emailDataSchema);
                emailformDataSchema['feilds'].map((feild, key) => {
                    if (feild.name === 'emails') {
                        emailformDataSchema['feilds'][key]['value'] = ele.value;
                        emailformDataSchema['feilds'][key]['valid'] = false;
                        emailformDataSchema['feilds'][key]['errors'] = [];
                    }

                })
                this.setState({ 'emailformData': emailformDataSchema['feilds'] });
            }
            
            else if (ele.name === "break_time" || ele.name === "number_of_breaks") {
                let { breaksformData, } = this.state;
                breaksformData.map((feild, key) => {
                    if (feild.name === ele.name) {
                        // breaksformData[key]['value'] = event.target && event.target.value ? Number(event.target.value) : null;
                        breaksformData[key]['value'] = ele.value;
                        breaksformData[key]['text'] = ele.value;
                        breaksformData[key]['errors'] = [];
                    }
                })
                this.setState({ 'breaksformData': breaksformData });
            }

            
            else {
                this.state.formData.map((data, key) => { });
            }
        }
    }
    
    
    switchChange(status, id, index) {
        const { disableconfigurationsbyid } = networkList;
        // console.log(`switch to ${status}`);
        // console.log(typeof (status));
        try {
            if (status == true) {
                postService(disableconfigurationsbyid, 'POST', {
                    'id': id,
                    'status': 1,
                    'updated_at': this.state.date
                }).then(res => {
                    if (res.status) {
                        Modal.success({
                            title: 'Success',
                            content: res.message ? res.message : 'Your changes has been updated.',
                        });

                        this.getconfigurations();
                        // console.log('res', res)
                    } else {
                        // alert('Data not inserted');
                        Modal.error({
                            title: 'Failure',
                            content: res.message ? res.message : 'Oops! something went wrong... Please try again.',
                        });
                    }
                })
                // this.getconfigurations();
            } else {
                postService(disableconfigurationsbyid, 'POST', {
                    'id': id,
                    'status': 0,
                    'updated_at': this.state.date
                }).then(res => {
                    if (res.status) {
                        Modal.success({
                            title: 'Success',
                            content: res.message ? res.message : 'Your changes has been updated.',
                        });
                        this.getconfigurations();
                        // console.log('res', res)
                    } else {
                        // alert('Data not inserted');
                        // Modal.error({
                        //     title: 'Failure',
                        //     content: "Oops, something went wrong... Please try again.",
                        // });
                        Modal.error({
                            title: 'Failure',
                            content: res.message ? res.message : 'Oops! something went wrong... Please try again.',
                        });
                    }
                })
                // this.getconfigurations();
            }
        } catch (error) {
            Modal.error({
                title: 'Failure',
                content: "Oops, something went wrong... Please try again.",
            });
        }
    }
    showModal = (item) => {
        var bill_id = parseInt(item.id)
        var bill_percentage = (item.bill_tracking_percent)
        let { formData } = this.state
        formData.map((feild, key) => {
            if (feild['name'] === 'percentage') {
                formData[key]['value'] = null;
                formData[key]['text'] = null;
            }
        })
        formData.map((feild, key) => {
            if (feild['name'] === 'percentage') {
                formData[key]['value'] = bill_percentage;
                formData[key]['text'] = bill_percentage;
            }
        })
        this.setState({ 'formData': formData });
        this.setState((state) => ({ bill_percentage: bill_percentage, bill_id: bill_id, visible: true, title: item.config_name }), () => {



        })
    }
    showSMS = (percentage, id, unit_id, exclude_departments) => {
        var bill_id = parseInt(id)
        var bill_percentage = parseInt(percentage)

        // console.log('privilege_id:', this.state.privilege_id)
        // console.log('bill_id:', bill_id)
        this.setState((state) => ({ bill_percentage: bill_percentage, bill_id: bill_id, smsmodal: true, smsUnit_id: unit_id }), () => {
            let smsformSchema = Object.assign({}, smsformDataSchema);
            smsformSchema['feilds'].map((feild, key) => {
                if (feild['name'] === 'exclude_departments') {
                    smsformSchema['feilds'][key]['value'] = exclude_departments;
                }
            })
            this.setState({ 'formData': smsformSchema['feilds'] });

        })
    }
    showICU = (percentage, id, unit_id, include_departments) => {
        var bill_id = parseInt(id)
        var bill_percentage = parseInt(percentage)

        // console.log('privilege_id:', this.state.privilege_id)
        // console.log('bill_id:', bill_id)
        this.setState((state) => ({ bill_percentage: bill_percentage, bill_id: bill_id, icumodal: true, smsUnit_id: unit_id }), () => {
            let icuformDataSchema = Object.assign({}, icuDataSchema);
            icuformDataSchema['feilds'].map((feild, key) => {
                if (feild['name'] === 'include_departments') {
                    icuformDataSchema['feilds'][key]['value'] = include_departments;
                }
            })
            this.setState({ 'formData': icuformDataSchema['feilds'] });

        })
    }
    showEmail = (id, unit_id, emailList) => {
        var bill_id = parseInt(id)
        // let emailIds = emailList && emailList.length ?  emailList.map(ele => ele.email_name) : [];
        this.setState((state) => ({ bill_id: bill_id, emailmodal: true, emailList: emailList }), () => {
            let emailformDataSchema = Object.assign({}, emailDataSchema);
            emailformDataSchema['feilds'].map((feild, key) => {
                if (feild['name'] === 'emails') {
                    emailformDataSchema['feilds'][key]['value'] = null;
                }
                if (feild.name === 'multiple_unit') {
                    emailformDataSchema['feilds'][key]['value'] = [];
                    emailformDataSchema['feilds'][key]['valid'] = false;
                    emailformDataSchema['feilds'][key]['errors'] = [];
                    emailformDataSchema['feilds'][key]['text'] = 'Select Unit';
                }
            })
            this.setState({ 'emailformData': emailformDataSchema['feilds'] });
        })
    }

    showAddCheckList = (id, unit_id, emailList) => {
        var bill_id = parseInt(id)
        // let emailIds = emailList && emailList.length ?  emailList.map(ele => ele.email_name) : [];
        this.setState((state) => ({ bill_id: bill_id, checklistmodal: true, emailList: emailList }), () => {
            let checkListAddformDataSchema = Object.assign({}, checkListAddDataSchema);
            checkListAddformDataSchema['feilds'].map((feild, key) => {
                if (feild['name'] === 'emails') {
                    checkListAddformDataSchema['feilds'][key]['value'] = null;
                }
            })
            this.setState({ 'checklistaddformData': checkListAddformDataSchema['feilds'],textValue:null });
        })
    }

    showAddNmeList = (id, unit_id, emailList) => {
        var bill_id = parseInt(id)
        // let emailIds = emailList && emailList.length ?  emailList.map(ele => ele.email_name) : [];
        this.setState((state) => ({ bill_id: bill_id, nmelistmodal: true, emailList: emailList }), () => {
            let nmeListAddformDataSchema = Object.assign({}, nmeListAddDataSchema);
            nmeListAddformDataSchema['feilds'].map((feild, key) => {
                if (feild['name'] === 'emails') {
                    nmeListAddformDataSchema['feilds'][key]['value'] = null;
                }
            })
            this.setState({ 'nmelistaddformData': nmeListAddformDataSchema['feilds'], descriptionValue: null});
        })
    }
    validateModalFeilds(formFeilds) {
        // console.log("validateModalFeilds",formFeilds);
        let errors = [];
        let role_id = null;
        formFeilds.map((feild, key) => {
            if (feild['element'] === 'input' || feild['element'] === 'select2' || feild['element'] === 'date' || feild['element'] === 'select2multiple') {
                if (feild['name'] === 'role_id' && feild['value'] === 'RL_fm8f') {
                    role_id = true;
                } else {
                    role_id = false;
                }
                formFeilds[key]['errors'] = [];
                if (!feild.disable) {
                    feild
                        .rules
                        .map((rule, rkey) => {
                            if (rule.test !== undefined && typeof rule.test === 'function' && !rule.test(feild['value'])) {
                                formFeilds[key]['errors'].push({ 'message': rule.message });
                                errors.push(false);
                            }
                        })
                }
            }
            if (role_id !== null && role_id) {

            }
        })

        this.setState((state) => ({ formData: formFeilds }));
        return errors;
    }
    handleCancel = e => {
        // console.log(e)
        let formSchema = Object.assign({}, formDataSchema);
        formSchema['feilds'].map((feild, key) => {
            formSchema['feilds'][key]['value'] = null;
            formSchema['feilds'][key]['valid'] = false;
            formSchema['feilds'][key]['errors'] = [];
            delete formSchema['feilds'][key]['text'];
        })
        this.setState({ visible: false, 'formData': formSchema['feilds'] });
    }
    smshandleCancel = e => {
        // console.log(e)
        let smsformSchema = Object.assign({}, smsformDataSchema);
        smsformSchema['feilds'].map((feild, key) => {
            smsformSchema['feilds'][key]['value'] = null;
            smsformSchema['feilds'][key]['valid'] = false;
            smsformSchema['feilds'][key]['errors'] = [];
            delete smsformSchema['feilds'][key]['text'];
        })
        this.setState({ 'smsmodal': false, 'smsformData': smsformSchema['feilds'] });
    }
    icuhandleCancel = e => {
        // console.log(e)
        let icuformDataSchema = Object.assign({}, icuDataSchema);
        icuformDataSchema['feilds'].map((feild, key) => {
            icuformDataSchema['feilds'][key]['value'] = null;
            icuformDataSchema['feilds'][key]['valid'] = false;
            icuformDataSchema['feilds'][key]['errors'] = [];
            delete icuformDataSchema['feilds'][key]['text'];
        })
        this.setState({ 'icumodal': false, 'icuformData': icuformDataSchema['feilds'] });
    }
    emailhandleCancel = e => {
        // console.log(e)
        let emailformDataSchema = Object.assign({}, emailDataSchema);
        emailformDataSchema['feilds'].map((feild, key) => {
            if (feild.name === 'multiple_unit') {
                emailformDataSchema['feilds'][key]['value'] = [];
                emailformDataSchema['feilds'][key]['valid'] = false;
                emailformDataSchema['feilds'][key]['errors'] = [];
                emailformDataSchema['feilds'][key]['text'] = 'Select Unit';
            } else {
                emailformDataSchema['feilds'][key]['value'] = null;
                emailformDataSchema['feilds'][key]['valid'] = false;
                emailformDataSchema['feilds'][key]['errors'] = [];
                delete emailformDataSchema['feilds'][key]['text'];
            }

        })
        this.setState({ 'emailmodal': false, 'emailformData': emailformDataSchema['feilds'] });
    }

    checkListAddHandleCancel = e => {
        // console.log(e)
        let checkListAddformDataSchema = Object.assign({}, checklistDataSchema);
        checkListAddformDataSchema['feilds'].map((feild, key) => {

            checkListAddformDataSchema['feilds'][key]['value'] = null;
            checkListAddformDataSchema['feilds'][key]['valid'] = false;
            checkListAddformDataSchema['feilds'][key]['errors'] = [];
            delete checkListAddformDataSchema['feilds'][key]['text'];

        })
        this.setState({ 'checklistmodal': false, 'checklistaddformData': checkListAddformDataSchema['feilds'] });
    }

    nmeListAddHandleCancel = e => {
        //let nmeListAddformDataSchema = Object.assign({}, nmelistDataSchema);
        let nmeListAddformDataSchema = Object.assign({}, nmeListAddDataSchema);
        console.log('nmeListAddformDataSchema', nmeListAddformDataSchema);
        nmeListAddformDataSchema['feilds'].map((feild, key) => { 
            // nmeListAddformDataSchema['feilds'][key]['value'] = null;
            // nmeListAddformDataSchema['feilds'][key]['valid'] = false;
            // nmeListAddformDataSchema['feilds'][key]['errors'] = [];
            // delete nmeListAddformDataSchema['feilds'][key]['text'];
            if (feild.name === 'unit') {
                nmeListAddformDataSchema['feilds'][key]['value'] = [];
                nmeListAddformDataSchema['feilds'][key]['valid'] = false;
                nmeListAddformDataSchema['feilds'][key]['errors'] = [];
                nmeListAddformDataSchema['feilds'][key]['text'] = 'Select Unit';
            }
            else if (feild.name === 'department') {
                nmeListAddformDataSchema['feilds'][key]['value'] = [];
                nmeListAddformDataSchema['feilds'][key]['valid'] = false;
                nmeListAddformDataSchema['feilds'][key]['errors'] = [];
                nmeListAddformDataSchema['feilds'][key]['text'] = 'Select Department';
            }
             else {
                nmeListAddformDataSchema['feilds'][key]['value'] = null;
                nmeListAddformDataSchema['feilds'][key]['valid'] = false;
                nmeListAddformDataSchema['feilds'][key]['errors'] = [];
                delete nmeListAddformDataSchema['feilds'][key]['text'];
            }

        })
        this.setState({ 'nmelistmodal': false, 'nmelistaddformData': nmeListAddformDataSchema['feilds'] });
    }    
        
    updatesms = () => {
        const { addSMSExcludeDepartments } = networkList;
        // console.log(this.state.formData)
        try {
            const { smsformData } = this.state
            var formFeilds = smsformData;
            let errors = this.validateModalFeilds(formFeilds)
            var exclude = formFeilds[0].value;
            if (!errors.includes(false)) {

                this.setState((state) => ({ btnloading: true }), () => {
                    postService(addSMSExcludeDepartments, 'POST', {
                        "data": {
                            'unit_id': this.state.smsUnit_id,
                            'exclude_departments': exclude
                        }
                    }).then(res => {
                        if (res.status) {
                            this.setState((state) => ({ btnloading: false, smsmodal: false }));
                            this.getconfigurations();
                            Modal.success({
                                title: 'Success',
                                content: res.message ? res.message : 'Your changes has been updated.',
                            });
                        } else {
                            this.setState((state) => ({ btnloading: false, smsmodal: false }));
                            Modal.error({
                                title: 'Failure',
                                content: res.message ? res.message : 'Oops! something went wrong... Please try again.',
                            });
                        }
                    })
                });
                // this.getconfigurations();
                let smsformSchema = Object.assign({}, smsformDataSchema);
                smsformSchema['feilds'].map((feild, key) => {
                    smsformSchema['feilds'][key]['value'] = null;
                    smsformSchema['feilds'][key]['valid'] = false;
                    smsformSchema['feilds'][key]['errors'] = [];
                    delete smsformSchema['feilds'][key]['text'];
                })
                this.setState({ 'smsformData': smsformSchema['feilds'] });
            }
        } catch (error) {
            Modal.error({
                title: 'Failure',
                content: "Oops, something went wrong... Please try again.",
            });
        }

    }
    updateICU = () => {
        const { addICUTaggedDepartments } = networkList;
        // console.log(this.state.formData)
        try {
            const { icuformData } = this.state
            var formFeilds = icuformData;
            let errors = this.validateModalFeilds(formFeilds)
            var include = formFeilds[0].value;
            if (!errors.includes(false)) {
                this.setState((state) => ({ btnloading: true }), () => {
                    postService(addICUTaggedDepartments, 'POST', {
                        "data": {
                            'unit_id': this.state.smsUnit_id,
                            'include_departments': include
                        }
                    }).then(res => {
                        if (res.status) {
                            this.setState((state) => ({ btnloading: false, icumodal: false }));
                            this.getconfigurations();
                            Modal.success({
                                title: 'Success',
                                content: res.message ? res.message : 'Your changes has been updated.',
                            });
                        } else {
                            this.setState((state) => ({ btnloading: false, icumodal: false }));
                            Modal.error({
                                title: 'Failure',
                                content: res.message ? res.message : 'Oops! something went wrong... Please try again.',
                            });
                        }
                    })
                });
                // this.getconfigurations();
                let icuformDataSchema = Object.assign({}, icuDataSchema);
                icuformDataSchema['feilds'].map((feild, key) => {
                    icuformDataSchema['feilds'][key]['value'] = null;
                    icuformDataSchema['feilds'][key]['valid'] = false;
                    icuformDataSchema['feilds'][key]['errors'] = [];
                    delete icuformDataSchema['feilds'][key]['text'];
                })
                this.setState({ 'icuformData': icuformDataSchema['feilds'] });
            }
        } catch (error) {
            Modal.error({
                title: 'Failure',
                content: "Oops, something went wrong... Please try again.",
            });
        }

    }
    deleteMailID = (id) => {
        const { emailList } = this.state;
        let filteredList = emailList.filter(ele => ele.id !== id)
        this.setState({ mailIdToDelete: id, emailList: filteredList }, () => this.updateEmailList())
    }
    updateEmailList = () => {
        const { deleteMail } = networkList;
        try {
            const { userData, mailIdToDelete } = this.state
            let errors = [];
            mailIdToDelete ? errors.push(true) : errors.push(false);
            if (!errors.includes(false)) {
                this.setState((state) => ({ btnloading: true }), () => {
                    postService(deleteMail, 'POST', {
                        "data": {
                            "id": mailIdToDelete,
                            "updated_by": userData ? userData.username : null,
                            "status": 0
                        }
                    }).then(res => {
                        if (res.status) {
                            this.setState((state) => ({ btnloading: false, emailmodal: false }));
                            this.getconfigurations();
                            Modal.success({
                                title: 'Success',
                                content: res.message ? res.message : 'Your changes has been updated.',
                            });
                        } else {
                            this.setState((state) => ({ btnloading: false, emailmodal: false }));
                            Modal.error({
                                title: 'Failure',
                                content: res.message ? res.message : 'Oops! something went wrong... Please try again.',
                            });
                        }
                    })
                });
                // this.getconfigurations();
                let emailformDataSchema = Object.assign({}, emailDataSchema);
                emailformDataSchema['feilds'].map((feild, key) => {
                    if (feild.name === 'multiple_unit') {
                        emailformDataSchema['feilds'][key]['value'] = [];
                        emailformDataSchema['feilds'][key]['valid'] = false;
                        emailformDataSchema['feilds'][key]['errors'] = [];
                        emailformDataSchema['feilds'][key]['text'] = 'Select Unit';
                    } else {
                        emailformDataSchema['feilds'][key]['value'] = null;
                        emailformDataSchema['feilds'][key]['valid'] = false;
                        emailformDataSchema['feilds'][key]['errors'] = [];
                        delete emailformDataSchema['feilds'][key]['text'];
                    }
                })
                this.setState({ 'emailformData': emailformDataSchema['feilds'] });
            } else {
                Modal.error({
                    title: 'Failure',
                    content: 'No Email Id is selected to delete.',
                });
            }
        } catch (error) {
            Modal.error({
                title: 'Failure',
                content: "Oops, something went wrong... Please try again.",
            });
        }
    }
    validateEmailId = (formFeilds) => {
        var validRegex = /^\S+@\S+\.\S+$/
        if (formFeilds[0]["value"] !== null && formFeilds[0]["value"] !== '' && formFeilds[0]["value"] !== undefined) {
            if (formFeilds && formFeilds[0]["value"] && formFeilds[0]["value"].match(validRegex)) {
                return true
            } else return false
        } else return false
    }
    addEmails = () => {
        const { createUserMail } = networkList;
        try {
            const { emailformData, userData } = this.state
            var formFeilds = emailformData;
            let errors = this.validateModalFeilds(formFeilds)
            let validEmailId = this.validateEmailId(formFeilds)
            console.log("validEmailId", validEmailId, formFeilds);
            if (!errors.includes(false) && validEmailId) {
                this.setState((state) => ({ btnloading: true }), () => {
                    postService(createUserMail, 'POST', {
                        "data": {
                            "email_name": formFeilds[0]["value"],
                            "unit_id": formFeilds[1]["value"].toString(),
                            "created_by": userData ? userData.username : null,
                        }
                    }).then(res => {
                        if (res.status) {
                            if (res.data == 1) {
                                this.setState((state) => ({ btnloading: false, emailmodal: false }));
                                this.getconfigurations();
                                Modal.success({
                                    title: 'Success',
                                    content: res.message ? res.message : 'Your changes has been updated.',
                                });
                            } else {
                                this.setState((state) => ({ btnloading: false, emailmodal: false }));
                                this.getconfigurations();
                                Modal.warning({
                                    title: 'Warning',
                                    content: res.message ? res.message : 'Your changes has been updated.',
                                });
                            }

                        } else {
                            this.setState((state) => ({ btnloading: false, emailmodal: false }));
                            Modal.error({
                                title: 'Failure',
                                content: res.message ? res.message : 'Oops! something went wrong... Please try again.',
                            });
                        }
                        let emailformDataSchema = Object.assign({}, emailDataSchema);
                        emailformDataSchema['feilds'].map((feild, key) => {
                            if (feild.name === 'multiple_unit') {
                                emailformDataSchema['feilds'][key]['value'] = [];
                                emailformDataSchema['feilds'][key]['valid'] = false;
                                emailformDataSchema['feilds'][key]['errors'] = [];
                                emailformDataSchema['feilds'][key]['text'] = 'Select Unit';
                            } else {
                                emailformDataSchema['feilds'][key]['value'] = null;
                                emailformDataSchema['feilds'][key]['valid'] = false;
                                emailformDataSchema['feilds'][key]['errors'] = [];
                                delete emailformDataSchema['feilds'][key]['text'];
                            }
                        })
                        this.setState({ 'emailformData': emailformDataSchema['feilds'] });
                    })
                });
                // this.getconfigurations();
            } else if (validEmailId === false) {
                Modal.error({
                    title: 'Failure',
                    content: "Please enter valid Email Id.",
                });
            }
        } catch (error) {
            Modal.error({
                title: 'Failure',
                content: "Oops, something went wrong... Please try again.",
            });
        }
    }


    addCheckList = () => {
        const { saveFCChecklist } = networkList;
        try {
            const { checklistformData, userData,textValue } = this.state
            var formFeilds = checklistformData;
            let errors = this.validateModalFeilds(formFeilds)
            let validEmailId = this.validateEmailId(formFeilds)
            console.log("validEmailId", validEmailId, formFeilds);
            if (!errors.includes(false)) {
            this.setState((state) => ({ btnloading: true }), () => {
                postService('saveFCChecklist', 'POST', {
                    "data": {
                        "text": textValue,
                    }
                }).then(res => {
                    if (res.status) {
                        if (res.data == 1) {
                            console.log('ResData', res.data);
                            this.setState((state) => ({ btnloading: false, checklistmodal: false,textValue:null }));
                            this.getconfigurations();
                            Modal.warning({
                                title: 'Warning',
                                content: res.message ? res.message : 'New Key Point Added here',
                            });
                        }
                        else {
                            this.setState((state) => ({ btnloading: false, checklistmodal: false,textValue:null }));
                            this.getconfigurations();
                            Modal.success({
                                title: 'Success',
                                content: res.message ? res.message : 'New Key Point Added',
                            });
                            this.getCheckList();
                        }
                    
                    } else {
                        this.setState((state) => ({ btnloading: false, checklistmodal: true,textValue:null }));
                        Modal.error({
                            title: 'Failure',
                            content: res.message ? res.message : 'Already Added, please Add New Check List.',
                        });
                    }
                    let checkListAddformDataSchema = Object.assign({}, checkListAddDataSchema);
                    checkListAddformDataSchema['feilds'].map((feild, key) => {
                        checkListAddformDataSchema['feilds'][key]['value'] = null;
                        checkListAddformDataSchema['feilds'][key]['valid'] = false;
                        checkListAddformDataSchema['feilds'][key]['errors'] = [];
                        delete checkListAddformDataSchema['feilds'][key]['text'];
                    })
                    this.setState({ 'checklistaddformData': checkListAddformDataSchema['feilds'] });
                })
            });
             //this.getconfigurations();
            }
        } catch (error) {
            Modal.error({
                title: 'Failure',
                content: "Oops, something went wrong... Please try again.",
            });
        }
    }

    addNmeList = () => {
        const { saveFCChecklist, insertMasterNmeList } = networkList;
        try {
            const { nmelistaddformData, userData,descriptionValue} = this.state
            var formFeilds = nmelistaddformData;
            console.log('formFeilds', formFeilds);
            let errors = this.validateModalFeilds(formFeilds)
            let validEmailId = this.validateEmailId(formFeilds)
            console.log("validEmailId", validEmailId, formFeilds);
            let tariffIds = [];
                formFeilds.forEach((field, index) => {
                    if (field.name === 'tariff') {
                        if (typeof field.value === 'string') {
                            const splitValues = field.value.split(',').map(value => value.trim());
                            tariffIds.push(...splitValues);
                        } else {
                            tariffIds.push(...field.value);
                        }
                    }
                });
                tariffIds = Array.from(new Set(tariffIds));
            this.setState((state) => ({ btnloading: true }), () => {
            
                postService(insertMasterNmeList, 'POST', {
                    "data": {
                        "unit_id": formFeilds[0]["value"].toString(),
                        "dept_cd": formFeilds[1]["value"].toString(),
                        "tariff_id": tariffIds,
                        "description": descriptionValue,
                        "rate": formFeilds[4]["value"],
                        "created_by": userData ? userData.username : null,
                    }
                }).then(res => {
                    if (res.status) {
                        console.log('Status::', res.status);
                        if (res.data == 1) {
                            console.log('ResData', res.data);
                            this.setState((state) => ({ btnloading: false, nmelistmodal: false}));
                            this.getconfigurations();
                            Modal.warning({
                                title: 'Warning',
                                content: res.message ? res.message : 'New Key Point Added here',
                            });
                        }
                        else {
                            this.setState((state) => ({ btnloading: false, nmelistmodal: false}));
                            this.getconfigurations();
                            Modal.success({
                                title: 'Success',
                                content: res.message ? res.message : 'New NME Point Added',
                            });
                            this.getNmeList();
                        }
                    
                    } else {
                        console.log('Status::', res.status);
                        this.setState((state) => ({ btnloading: false, nmelistmodal: true}));
                        // Modal.error({
                        //     title: 'Failure',
                        //     content: res.message ? res.message : 'This Tariffs are Already Exist',
                        // });
                        Modal.error({
                            title: 'Failure',
                            content: (
                                <div>
                                    {res.message && <p>{res.message}</p>}
                                    {res.errors && res.errors.length > 0 && (
                                       <div>
                                            {res.errors.map((error, index) => (
                                                <li key={index}>{error}</li>
                                            ))}
                                      </div>
                                    )}
                                    {!res.message && (!res.errors || res.errors.length === 0) && (
                                        <p>This Tariffs are Already Exist</p>
                                    )}
                                </div>
                            ),
                        });
                                                                     
                    }
                    let nmeListAddformDataSchema = Object.assign({}, nmeListAddDataSchema);
                    nmeListAddformDataSchema['feilds'].map((feild, key) => {
                        if (feild.name === 'unit') {
                            nmeListAddformDataSchema['feilds'][key]['value'] = [];
                            nmeListAddformDataSchema['feilds'][key]['valid'] = false;
                            nmeListAddformDataSchema['feilds'][key]['errors'] = [];
                            nmeListAddformDataSchema['feilds'][key]['text'] = 'Select Unit';
                        } 
                        
                        else if (feild.name === 'department') {
                            nmeListAddformDataSchema['feilds'][key]['value'] = [];
                            nmeListAddformDataSchema['feilds'][key]['valid'] = false;
                            nmeListAddformDataSchema['feilds'][key]['errors'] = [];
                            nmeListAddformDataSchema['feilds'][key]['text'] = 'Select Department';
                        } 
                        else if (feild.name === 'tariff') {
                            nmeListAddformDataSchema['feilds'][key]['value'] = [];
                            nmeListAddformDataSchema['feilds'][key]['valid'] = false;
                            nmeListAddformDataSchema['feilds'][key]['errors'] = [];
                            nmeListAddformDataSchema['feilds'][key]['text'] = 'Select Tariff';
                        } 
                        else if (feild.name === 'description') {
                            nmeListAddformDataSchema['feilds'][key]['value'] = null;
                            nmeListAddformDataSchema['feilds'][key]['valid'] = false;
                            nmeListAddformDataSchema['feilds'][key]['errors'] = [];
                            delete nmeListAddformDataSchema['feilds'][key]['text'];
                        } 
            
                        else if (feild.name === 'rate') {
                            nmeListAddformDataSchema['feilds'][key]['value'] = null;
                            nmeListAddformDataSchema['feilds'][key]['valid'] = false;
                            nmeListAddformDataSchema['feilds'][key]['errors'] = [];
                            delete nmeListAddformDataSchema['feilds'][key]['text'];
                        }
            
            
                    })
                    this.setState({ 'nmelistaddformData': nmeListAddformDataSchema['feilds'] });
                    console.log('nmelistaddformData', this.state);
                })
            
            });
             //this.getconfigurations();
            // }
        } catch (error) {
            Modal.error({
                title: 'Failure',
                content: "Oops, something went wrong... Please try again.",
            });
        }
    }

    onClickCounsellingForm = () => {
        const { tbody, show1, show2, show3, show4, duplicateData } = this.state
        //console.log(tbody[0])
        console.log(tbody)
        //const remData = [tbody[0].id, tbody[0].unit_id, tbody[0].unit_name]
        this.setState({ show1: !show1, show2: false, show3: false, show4: false, show5: false, show6: false, show7: false})
        //let allData = tbody[0].data  
        //console.log(tbody[0].indexOf("data"))
        //const counsellingFormData = allData.filter(eachForm => eachForm.config_type === "counselling")  

        const cd = duplicateData[0].data.filter(eachForm => eachForm.config_type === "counselling")
        console.log(cd)
        //const counsellingFormData = duplicateData.map(piece => piece.data = cd) 
        let counselling = {}
        for (let each of duplicateData) {
            for (let obj in each) {
                if (obj === "data") {

                    counselling[obj] = cd

                } else {
                    counselling[obj] = each[obj]
                }
            }
        }
        let counsellingFormData = [counselling]
        console.log("counselling form data", counsellingFormData)



        this.setState({ tbody: counsellingFormData })
    }

    onClickTrackBilss = () => {
        const { tbody, show1, show2, show3, show4, duplicateData } = this.state
        this.setState({ show2: !show2, show1: false, show3: false, show4: false, show5: false, show6: false, show7: false})

        //console.log(tbody[0])



        //let allData = tbody[0].data  
        //console.log(tbody[0].indexOf("data"))
        //const counsellingFormData = allData.filter(eachForm => eachForm.config_type === "counselling")  

        const trackbills = duplicateData[0].data.filter(eachForm => eachForm.config_type === "trackbills")
        console.log(trackbills)
        //const counsellingFormData = duplicateData.map(piece => piece.data = cd) 
        let billstrack = {}
        for (let each of duplicateData) {
            for (let obj in each) {
                if (obj === "data") {

                    billstrack[obj] = trackbills

                } else {
                    billstrack[obj] = each[obj]
                }
            }
        }
        let trackBiilsData = [billstrack]
        console.log("trackbills form data", trackBiilsData)



        this.setState({ tbody: trackBiilsData })

    }



    onClickTokenAssign = () => {
        const { tbody, show1, show2, show3, show4, duplicateData } = this.state
        this.setState({ show3: !show3, show1: false, show2: false, show4: false, show5: false, show6: false, show7: false})
        const tokenbill = duplicateData[0].data.filter(eachForm => eachForm.config_type === "queue")
        //console.log(tokenbill)  
        //const counsellingFormData = duplicateData.map(piece => piece.data = cd) 
        let tokenBillObj = {}
        for (let each of duplicateData) {
            for (let obj in each) {
                if (obj === "data") {

                    tokenBillObj[obj] = tokenbill

                } else {
                    tokenBillObj[obj] = each[obj]
                }
            }
        }
        let tokenBiilsData = [tokenBillObj]
        console.log("tokenbills form data", tokenBiilsData)



        this.setState({ tbody: tokenBiilsData })
    }


    onClickSms = () => {
        const { tbody, show1, show2, show3, show4, duplicateData } = this.state
        this.setState({ show4: !show4, show1: false, show2: false, show3: false, show5: false, show6: false, show7: false})
        const smsbill = duplicateData[0].data.filter(eachForm => eachForm.config_type === "email")

        let smsBillObj = {}
        for (let each of duplicateData) {
            for (let obj in each) {
                if (obj === "data") {

                    smsBillObj[obj] = smsbill

                } else {
                    smsBillObj[obj] = each[obj]
                }
            }
        }
        let smsBiilsData = [smsBillObj]
        console.log("smsbills form data", smsBiilsData)



        this.setState({ tbody: smsBiilsData })
    }

    getCounsellingStationsDropDown = () => {
        try {
            let user_data
            if (localStorage.getItem('user_data') !== null && localStorage.getItem('user_data') !== undefined && localStorage.getItem('user_data') !== '') {
                user_data = JSON.parse(localStorage.getItem('user_data'))
            }
            postService('getCounsellingStationsDropDown', 'POST', { "unit_id": user_data['unitid'] ? user_data['unitid'] : '' }
            ).then(res => {

                if (res.status) {
                    this.setState((state) => ({ stationList: res.data, loading: false, fetching: false }), () => {

                    });
                } else {
                    this.setState({ stationList: [], fetching: false });
                }
            });
        } catch (error) {
            console.log(error);
            this.setState({ 'loadding': false });
        }
    }

    patientDetails = (id, value) => {
        postService('setCounsellingStation', 'POST', { 'id': id, "station_id": value }
        ).then(res => {
            if (res.status) {
                Modal.success({
                    title: 'Success Message',
                    content: `Added the Counselling Station`,
                    zIndex: 2000,
                })
                this.getconfigurations();
            }

        })

    }

    onClickBreak = () => {
        const { show5, } = this.state
        this.setState({ show1: false, show2: false, show3: false, show4: false, show5: true, show6: false, show7: false}, () => this.getBreakTimeReasonsList());
    }

    getCheckList = () => {
        console.log("here")
        try {
            let user_data
            if (localStorage.getItem('user_data') !== null && localStorage.getItem('user_data') !== undefined && localStorage.getItem('user_data') !== '') {
                user_data = JSON.parse(localStorage.getItem('user_data'))
            }
            postService('getFCChecklist', 'POST', { "data": { "unit_id": user_data['unitid'] ? user_data['unitid'] : '' } }
            ).then(res => {

                if (res.status) {
                    this.setState({ tbody: res.data });
                } else {
                    this.setState({ stationList: [], fetching: false });
                }
            });
        } catch (error) {
            console.log(error);
            this.setState({ 'loadding': false });
        }
    }

  
    getNmeList = () => {
        console.log("here")
        try {
            let user_data
            if (localStorage.getItem('user_data') !== null && localStorage.getItem('user_data') !== undefined && localStorage.getItem('user_data') !== '') {
                user_data = JSON.parse(localStorage.getItem('user_data'))
            }
            postService('getMasterNmeListByUnitid', 'POST', { "data": { "unit_id": user_data['unitid'] ? user_data['unitid'] : '' } }
            ).then(res => {

                if (res.status) {
                    this.setState({ tbody: res.data });
                } else {
                    this.setState({ stationList: [], fetching: false });
                }
            });
        } catch (error) {
            console.log(error);
            this.setState({ 'loadding': false });
        }
    }
      

    onClickCheckList = () => {
        this.setState({ show1: false, show2: false, show3: false, show4: false, show5: false, show6: true, show7: false}, () => this.getCheckList());
    }

    onClickNmeList = () => {
        this.setState({ show1: false, show2: false, show3: false, show4: false, show5: false, show6: false, show7: true}, () => this.getNmeList());
    }


    getBreakTimeReasonsList = () => {
        postService(getBreakTimeReasonsList, "GET", null).then(res => {
            if (res.status) {
                this.setState({ tbody: res.data })
            }
        })
    }

    showBreaksModal = (data) => {
        let { breaksformData, } = this.state;
        breaksformData.map((feild, key) => {
            console.log('feild', feild)
            if (feild.name === "break_time" || feild.name === "number_of_breaks") {
                breaksformData[key]['value'] = data[feild.name];
                breaksformData[key]['text'] = data[feild.name];
                breaksformData[key]['errors'] = [];
            }
        })
        this.setState({ 'breaksformData': breaksformData, breaksDetails: data, breakModalVisible: true })
        console.log('State', this.state)
    }

    showCheckModal = (data) => {
        let { checklistformData, } = this.state;
        checklistformData.map((feild, key) => {
            if (feild.name === "checklist") {
                checklistformData[key]['value'] = data["text"];
                checklistformData[key]['text'] = data["text"];
                checklistformData[key]['errors'] = [];
            }
        })
        this.setState({ 'checklistformData': checklistformData, checklistDetails: data, checkModalVisible: true,textValue:data['text'] })
    }

    showNmeModal = (data) => {
        let { nmelistformData, userData} = this.state;
        nmelistformData.map((feild, key) => {
            if (feild.name === "unit") {
                nmelistformData[key]['value'] = data.unit_id;
                nmelistformData[key]['text'] = data.unitname;
                nmelistformData[key]['errors'] = [];
            }
            if (feild.name === "department") {
                nmelistformData[key]['value'] = data.dept_cd;
                nmelistformData[key]['text'] = data.dept_cd;
                nmelistformData[key]['errors'] = [];
            }
            if (feild.name === "tariff") {
                nmelistformData[key]['value'] = data.tariff_id;
                nmelistformData[key]['text'] = data.name;
                nmelistformData[key]['errors'] = [];
            }
            if (feild.name === "description") {
                nmelistformData[key]['value'] = data["description"];
                nmelistformData[key]['text'] = data["description"];
                nmelistformData[key]['errors'] = [];
            }
            if (feild.name === "rate") {
                nmelistformData[key]['value'] = data[feild.name];
                nmelistformData[key]['text'] = data[feild.name];
                nmelistformData[key]['errors'] = [];
            }
        })
        this.setState({ 'nmelistformData': nmelistformData, nmelistDetails: data, nmeModalVisible: true,descriptionValue:data['description'] })
    }




    updateBreakTimeandBreakCount = () => {
        const { breaksformData, breaksDetails, userData, } = this.state;
        let errors = this.validateModalFeilds(breaksformData)
        let payload = {
            "id": breaksDetails["id"],
            // "reason": breaksDetails["reason"],
            "number_of_breaks": null,
            "break_time": null,
            "updated_by": userData ? userData.username : null,
        }
        breaksformData.map((feild, key) => {
            if (feild.name === "break_time" || feild.name === "number_of_breaks") {
                payload[feild.name] = feild.value
            }
        })
        // console.log("updateBreakTimeandBreakCount breaksformData", breaksformData);
        // console.log("updateBreakTimeandBreakCount errors", errors);
        // console.log("updateBreakTimeandBreakCount payload", payload)

        if (!errors.includes(false)) {
            // console.log("updateBreakTimeandBreakCount payload", payload)
            // return
            postService(updateBreakTimeandBreakCount, "PUT", { data: payload }).then(res => {
                if (res.status) {
                    this.setState({ breakModalVisible: false }, () => this.getBreakTimeReasonsList())
                    Modal.success({
                        title: 'Success',
                        content: res.messsage,
                    });
                }
            })
        }
    }

    breakshandleCancel = () => {
        let { breaksformData, } = this.state;
        breaksformData.map((feild, key) => {
            breaksformData[key]['value'] = null;
            breaksformData[key]['text'] = null;
            breaksformData[key]['errors'] = [];
        })
        this.setState({ 'breakModalVisible': false, 'breaksformData': breaksformData });
    }

    updateCheckList = () => {
        const { checklistformData, checklistDetails, userData,textValue} = this.state;
        // return;
        let errors = this.validateModalFeilds(checklistformData)
        let payload = {
            "id": checklistDetails["id"],
            //"text": null
            // "id": checklistDetails["id"],
            // // "reason": checklistDetails["reason"],
            "text": null,
            // // "updated_by": userData ? userData.username : null,
        }
        checklistformData.map((feild, key) => {
            if (feild.name === "checklist") {
                payload["text"] = textValue
            }
        })
        // console.log("updateBreakTimeandBreakCount breaksformData", breaksformData);
        // console.log("updateBreakTimeandBreakCount errors", errors);
        // console.log("updateBreakTimeandBreakCount payload", payload)

        if (!errors.includes(false)) {
            // console.log("updateBreakTimeandBreakCount payload", payload)
            // return
            postService('updateFCChecklist', "POST", { data: payload }).then(res => {
                if (res.status) {
                    this.setState({ checkModalVisible: false,textValue:null }, () => this.getCheckList())
                    Modal.success({
                        title: 'Success',
                        content: res.messsage,
                    });
                }
            })
        }
    }

    updatenmeList = () => {
        const { nmelistformData,nmelistDetails, userData,descriptionValue} = this.state;
        let payload = {
            "id": nmelistDetails["id"],
            "unit_id": nmelistformData[0]["value"].toString(),
            "dept_cd": nmelistformData[1]["value"].toString(),
            "tariff_id": nmelistformData[2]["value"].toString(),
            "description": null,
            "rate": null,
            
        }
        nmelistformData.map((feild, key) => {
            if (feild.name === "unit") {
                payload[feild.name] = feild.value
            }
            if (feild.name === "department") {
                payload[feild.name] = feild.value
            }
            if (feild.name === "tariff") {
                payload[feild.name] = feild.value
            }
            if (feild.name === "description") {
                payload['description'] = descriptionValue
            }
            if (feild.name === "rate") {
                payload[feild.name] = feild.value
            }
        })

            postService('updateMasterNmeList', "POST", { data: payload }).then(res => {
                if (res.status) {
                    this.setState({ nmeModalVisible: false,descriptionValue:null }, () => this.getNmeList())
                    Modal.success({
                        title: 'Success',
                        content: res.message ? res.message : 'Data updated successfully.',
                    });
                }
                else {
                    this.setState((state) => ({ message: res.message, loadding: false }));
                        Modal.error({
                            title: 'Failure',
                            content: res.message ? res.message : "Please Change Unit , Department, Tariff, Rate.."
                        });
                }
            })
    }

    checklisthandleCancel = () => {
        let { checklistformData, } = this.state;
        checklistformData.map((feild, key) => {
            checklistformData[key]['value'] = null;
            checklistformData[key]['text'] = null;
            checklistformData[key]['errors'] = [];
        })
        this.setState({ 'checkModalVisible': false, 'checklistformData': checklistformData });
    }

    nmelisthandleCancel = () => {
        let { nmelistformData, } = this.state;
        nmelistformData.map((feild, key) => {
            nmelistformData[key]['value'] = null;
            nmelistformData[key]['text'] = null;
            nmelistformData[key]['errors'] = [];
        })
        this.setState({ 'nmeModalVisible': false, 'nmelistformData': nmelistformData });
    }

    handleChangeTextarea=(event)=>{
        let value = event.target.value;
        let checklistformDataSchema = Object.assign({}, checklistDataSchema);
        checklistformDataSchema['feilds'].map((feild, key) => {
            if (feild.name === 'checklist') {
                checklistformDataSchema['feilds'][key]['value'] = value;
                checklistformDataSchema['feilds'][key]['text'] = value;
                checklistformDataSchema['feilds'][key]['errors'] = [];
            }

        })
        this.setState({ 'checklistformData': checklistformDataSchema['feilds'],textValue:value });
    }

    handleChangeNmeTextarea=(event)=>{
        let value = event.target.value;
        let nmelistformDataSchema = Object.assign({}, nmelistDataSchema);
        nmelistformDataSchema['feilds'].map((feild, key) => {
 
        })
        this.setState({ 'nmelistformData': nmelistformDataSchema['feilds'], descriptionValue:value });
    }
    render() {
        let { thead, tbody, formData, cbody, smsmodal, smsformData, title, icumodal, icuformData, emailmodal, checklistmodal, nmelistmodal, emailformData, nmeListAddformDataSchema,nmelistaddformData, checklistaddformData, emailList, show1, show2, show3, show4, show5, show6, show7, stationList, breakModalVisible, breaksformData, checklistformData, nmelistformData, breaksDetails, checklistDetails, checkModalVisible, nmeModalVisible, textValue, descriptionValue, rateValue } = this.state;


        const showAddButton = show6; // Condition to determine when to show the Add button
        const showAddButton2 = show7;
        return (
            <div >
                {/* <div style={{marginLeft: '80%'}}>
                <button className="btn btn-success text-capitalize px-5 mx-2" onClick={this.showModal}>Add</button>
                </div> */}
                <div>
                    <div className='config-tab-card mt-5 ml-5'>
                        <button
                            type="button"
                            className={show1 ? 'config-tab-head2' : 'config-tab-head'}
                            onClick={this.onClickCounsellingForm}
                        >
                            Counselling Form
                        </button>
                        <button
                            type="button"
                            className={show2 ? 'config-tab-head2' : 'config-tab-head'}
                            onClick={this.onClickTrackBilss}
                        >
                            Track Bills
                        </button>
                        <button
                            type="button"
                            className={show3 ? 'config-tab-head2' : 'config-tab-head'}
                            onClick={this.onClickTokenAssign}
                        >
                            Token Assign
                        </button>
                        <button
                            type='button'
                            className={show4 ? 'config-tab-head2' : 'config-tab-head'}
                            onClick={this.onClickSms}
                        >
                            SMS & Email
                        </button>
                        <button
                            type='button'
                            className={show5 ? 'config-tab-head2' : 'config-tab-head'}
                            onClick={this.onClickBreak}
                        >
                            Timed Breaks
                        </button>
                        <button
                            type='button'
                            className={show6 ? 'config-tab-head2' : 'config-tab-head'}
                            onClick={this.onClickCheckList}
                        >
                            Check List
                        </button>
                        <button
                            type='button'
                            className={show7 ? 'config-tab-head2' : 'config-tab-head'}
                            onClick={this.onClickNmeList}
                        >
                            NME List
                        </button>
                        {/* {showAddButton && (
                            <button className="btn btn-success text-capitalize px-5 mx-2" onClick={this.showModalStatic}>Add</button>
                        )} */}
                    </div>

                    {/* {showAddButton && (
                            <div>
                            <button className="btn btn-success text-capitalize px-5 mx-2" onClick={this.showModal}>Add</button>
                            </div>
                        )} */}
                </div>
                {/* <div className='config-tab-card mt-5 ml-5'>
                    <button type="button" className={show1 ? 'config-tab-head2' : 'config-tab-head'} onClick={this.onClickCounsellingForm} >Counselling Form </button> 
                    <button type="button" className={show2 ? 'config-tab-head2' : 'config-tab-head'} onClick={this.onClickTrackBilss}>Track Bills</button>
                    <button type="button" className={show3 ? 'config-tab-head2' : 'config-tab-head'} onClick={this.onClickTokenAssign }>Token Assign </button>
                    <button type='button' className={show4 ? 'config-tab-head2' : 'config-tab-head'} onClick={this.onClickSms }>SMS & Email </button>
                    <button type='button' className={show5 ? 'config-tab-head2' : 'config-tab-head'} onClick={this.onClickBreak}>Timed Breaks</button>
                    <button type='button' className={show6 ? 'config-tab-head2' : 'config-tab-head'} onClick={this.onClickCheckList}>Check List</button>
               </div> */}

                <div className="card mb-5 ml-5 mr-5 mt-4 card-table ">
                    {/*<h1 className="text-heading text-center pt-5 pb-5">Configuration List</h1>*/}

                    <Spin spinning={this.state.loadding}>
                        <div className="financial-table table-responsive">
                            <table className="table table-hover table-bordered mb-0">
                                <thead>
                                    {show5 ? (
                                        <tr>
                                            <td style={{ width: '50px' }}>S.No</td>
                                            <td style={{ width: '200px' }}>Unit Name</td>
                                            <td style={{ width: '350px' }}>Types of Breaks</td>
                                            <td>Action</td>
                                            <td style={{ width: '150px' }}>Updated Date</td>
                                        </tr>
                                    ) : show6 ? (
                                        <tr>
                                            <td style={{ width: '50px' }}>S.No</td>
                                            <td style={{ width: '200px' }}>Unit Name</td>
                                            <td style={{ width: '850px' }}>Key Points</td>
                                            <td>Action</td>
                                            <td style={{ width: '150px' }}>Updated Date</td>
                                        </tr>
                                    ) : show7 ? (
                                        <tr>
                                            <td style={{ width: '50px' }}>S.No</td>
                                            <td style={{ width: '60px' }}>Unit Name</td>
                                            <td style={{ width: '800px' }}>Department</td>
                                            <td style={{ width: '1050px' }}>Description</td>
                                            <td style={{ width: '500px' }}>Tariff</td>
                                            <td style={{ width: '200px' }}>Rate</td>
                                            <td>Action</td>
                                            <td style={{ width: '300px' }}>Updated Date</td>
                                        </tr>
                                    ): (
                                        <tr>
                                            <td style={{ width: '50px' }}>S.No</td>
                                            <td style={{ width: '200px' }}>Unit Name</td>
                                            <td style={{ width: '350px' }}>Configuration Name</td>
                                            <td>Action</td>
                                            <td style={{ width: '150px' }}>Updated Date</td>
                                        </tr>
                                    )}
                                </thead>
                                {
                                    tbody != ''
                                        ?
                                        <tbody >
                                            {tbody.length > 0 && tbody.map((item, index) => {
                                                console.log('TABLE', item);
                                                return (<tr key={index}>
                                                    <td className="align-middle">{index + 1}</td>
                                                    <td className="text-capitalize align-middle">{(item.unit_name !== null) ? item.unit_name : '--'}</td>
                                                    <td className="text-capitalize p-0">
                                                        {show5
                                                            ? item.data.map((item, index) => {
                                                                return (
                                                                    <div key={index} className="group-td">
                                                                        {item.reason}
                                                                    </div>
                                                                )
                                                            })
                                                            : show6 ?
                                                                item.data.map((item, index) => {
                                                                    return (
                                                                        <div key={index} className="group-td" style={{height:'100%'}}>
                                                                            {item.text}
                                                                            {/* {item.text} Min - {item.number_of_breaks} Breaks
                                                                    <Tooltip title="Edit">
                                                                    <img src="/assets/images/icons/edit.png" alt="edit" className="pl-2" onClick={() => this.showBreaksModal(item)} />
                                                                    </Tooltip> */}
                                                                        </div>
                                                                    );
                                                                })
                                                                : show7 ?
                                                                // item.data.map((item, index) => {
                                                                //     return (
                                                                //         <div key={index} className="group-td" style={{ height:item.description&&(item.description).trim().length > 20?'84px':'100%',  width: item.dept_cd&&(item.dept_cd).trim().length>111?'300px':'100%'}}>
                                                                //             {item.dept_cd}
                                                                //         </div>
                                                                //     );
                                                                // })
                                                                item.data.map((item, index) => {
                                                                    return (
                                                                        <div key={index} className="group-td" style={{ height: item.description && item.description.trim().length > 104 ? '85px': '100%' , width: '100%' }}>
                                                                            {item.dept_cd && item.dept_cd.trim().length > 20 ? (
                                                                                <div>
                                                                                    {item.dept_cd.substring(0, 20)}<br />
                                                                                    {item.dept_cd.substring(20)}
                                                                                </div>
                                                                            ) : (
                                                                                <div>
                                                                                    {item.dept_cd}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    );
                                                                })
                                                                
                                                                : item.data.map((item, index) => {
                                                                    if (item.config_type === 'trackbills') {
                                                                        return (
                                                                            <div key={index} className="group-td">
                                                                                {(item.config_name !== null) ? item.config_name === 'Recounselling' || item.config_name === 'recounselling' ? 'Recounselling by Initial Counsellor' : item.config_name : '--'}
                                                                            </div>
                                                                        )
                                                                    } else if (item.config_type === 'queue') {
                                                                        if (item.config_name === 'ICU Tagged Departments') {
                                                                            return (
                                                                                <div key={index} className="group-td" style={{ height: item.config_name == 'ICU Tagged Departments' ? item.include_departments.length > 0 ? ((item.include_departments.length * 10) + 11) + 'px' : '100%' : '100%' }}>
                                                                                    {(item.config_name !== null) ? item.config_name === 'Recounselling' || item.config_name === 'recounselling' ? 'Recounselling by Initial Counsellor' : item.config_name : '--'}
                                                                                </div>
                                                                            )
                                                                        } else {
                                                                            return (
                                                                                <div key={index} className="group-td">
                                                                                    {(item.config_name !== null) ? item.config_name === 'Recounselling' || item.config_name === 'recounselling' ? 'Recounselling by Initial Counsellor' : item.config_name : '--'}
                                                                                </div>
                                                                            )
                                                                        }

                                                                    } else {
                                                                        return (
                                                                            <div key={index} className="group-td" style={{ height: item.config_name == 'Email' ? item.emailList.length > 0 ? ((item.emailList.length * 10) + 11) + 'px' : '100%' : '100%' }}>
                                                                                {(item.config_name !== null) ? item.config_name === 'Recounselling' || item.config_name === 'recounselling' ? 'Recounselling by Initial Counsellor' : item.config_name : '--'}
                                                                            </div>
                                                                        )
                                                                    }
                                                                })
                                                        }
                                                    </td>

                                                    {show7 && (
                                                        <td className="text-capitalize p-0">
                                                            {item.data.map((item, index) => (
                                                                <div key={index}  className="group-td" style={{height: item.dept_cd&& item.dept_cd.trim().length > 20 ? '63px': '64%'}}>
                                                                    <div>
                                                                        {item.description}
                                                                    </div>
                                                             
                                                                </div>
                                                            ))}
                                                        </td>
                                                    )}

                                                    {show7 && (
                                                        <td className="p-0">
                                                            {item.data.map((item, index) => (
                                                                <div key={index} className="group-td" 
                                                                style={{
                                                                    height: 
                                                                        (item.dept_cd && item.dept_cd.trim().length > 20) ? '63px' :
                                                                        (item.description && item.description.trim().length > 104) ? '84px' :
                                                                        '64%'
                                                                }}>
                                                                    <div>
                                                                        {item.name}
                                                                    </div>
                                                             
                                                                </div>
                                                            ))}
                                                        </td>
                                                    )}

                                                    {show7 && (
                                                        <td className="p-0">
                                                            {item.data.map((item, index) => (
                                                                <div key={index} className="group-td" 
                                                                style={{
                                                                    height: 
                                                                        (item.dept_cd && item.dept_cd.trim().length > 20) ? '63px' :
                                                                        (item.description && item.description.trim().length > 104) ? '84px' :
                                                                        '64%'
                                                                }}>
                                                                    <div>
                                                                        {item.rate}
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </td>
                                                    )}

                                                    <td className="p-0">
                                                        {show5 ? (
                                                            item.data.map((item, index) => (
                                                                <div key={index} className="group-td">
                                                                    {item.break_time} Min - {item.number_of_breaks} Breaks
                                                                    <Tooltip title="Edit">
                                                                        <img src={homepage+"/assets/images/icons/edit.png"} alt="edit" className="pl-2" onClick={() => this.showBreaksModal(item)} />
                                                                    </Tooltip>
                                                                </div>
                                                            ))
                                                        )
                                                            : show6 ?
                                                                item.data.map((item, index) => {
                                                                    return (
                                                                        <div key={index} className="group-td" style={{height:item.text&&(item.text).trim().length>111?'62px':'100%'}}>
                                                                            <Tooltip title="Edit">
                                                                                <img src={homepage+"/assets/images/icons/edit.png"} alt="edit" className="pl-2" onClick={() => this.showCheckModal(item)} />
                                                                            </Tooltip>
                                                                        </div>
                                                                    );
                                                                })
                                                                : show7 ?
                                                                item.data.map((item, index) => {
                                                                    return (
                                                                        <div key={index} className="group-td" 
                                                                        // style={{ height:item.description&&(item.description).trim().length > 20?'84px':'94%', width: '100px'}}
                                                                        style={{
                                                                            height: 
                                                                                (item.dept_cd && item.dept_cd.trim().length > 20) ? '63px' :
                                                                                (item.description && item.description.trim().length > 104) ? '84px' :
                                                                                '64%'
                                                                        }}
                                                                        >
                                                                            <Tooltip title="Edit">
                                                                                <img src={homepage+"/assets/images/icons/edit.png"} className="pl-2" onClick={() => this.showNmeModal(item)} />
                                                                            </Tooltip>
                                                                        </div>
                                                                    );
                                                                })
                                                                : item.data.map((item2, index) => {
                                                                    if (item2.config_name === 'SMS Exclude Departments') {
                                                                        return (
                                                                            <div key={index} className="group-td" style={{ height: '100%' }}>
                                                                                <Tooltip title="Edit">
                                                                                    <img src={homepage+"/assets/images/icons/edit.png"} alt="edit" className="pl-0 pr-2" onClick={() => this.showSMS(item2.bill_tracking_percent, item2.id, item.unit_id, item2.exclude_departments)} />
                                                                                </Tooltip>
                                                                                {item2.exclude_departments.map((data, key) => {
                                                                                    return <p className="badge badge-info mb-0 mr-1">{data}</p>
                                                                                })}
                                                                            </div>)
                                                                    } else if (item2.config_name === 'ICU Tagged Departments') {
                                                                        return (
                                                                            <div key={index} className="group-td" style={{ height: item2.config_name == 'ICU Tagged Departments' ? item2.include_departments.length > 0 ? ((item2.include_departments.length * 10) + 11) + 'px' : '100%' : '100%' }}>
                                                                                <Tooltip title="Edit">
                                                                                    <img src={homepage+"/assets/images/icons/edit.png"} alt="edit" className="pl-0 pr-2" onClick={() => this.showICU(item2.bill_tracking_percent, item2.id, item.unit_id, item2.include_departments)} />
                                                                                </Tooltip>
                                                                                {item2.include_departments.length > 0 && item2.include_departments.map((data, key) => {
                                                                                    return <p className="badge badge-info mb-0 mr-1">{data}</p>
                                                                                })}
                                                                            </div>)
                                                                    } else if (item2.config_name === 'Email') {
                                                                        return (
                                                                            <div key={index} className="group-td" style={{ height: item2.config_name == 'Email' ? item2.emailList.length > 0 ? ((item2.emailList.length * 10) + 11) + 'px' : '100%' : '100%' }}>
                                                                                <Tooltip title="Edit">
                                                                                    <img src={homepage+"/assets/images/icons/edit.png"} alt="edit" className="pl-0 pr-2" onClick={() => this.showEmail(item2.id, item.unit_id, item2.emailList)} />
                                                                                </Tooltip>
                                                                                {item2.emailList.length > 0 && item2.emailList.map((data, key) => {
                                                                                    return <p className="badge badge-info mb-0 mr-1">{data["email_id"]}</p>
                                                                                })}
                                                                            </div>)
                                                                    }
                                                                    else {
                                                                        if (item2.config_type === 'trackbills') {
                                                                            return (
                                                                                <div key={index} className="group-td" style={{ display: 'flex' }}>
                                                                                    {
                                                                                        item2.bill_tracking_percent
                                                                                            ? <div>
                                                                                                {(item2.bill_tracking_percent !== null) ? item2.bill_tracking_percent : '--'} {(item2.config_name !== 'Ins-Physician Fees ICU' && item2.config_name !== 'Ins-Physician Fees Room') && '%'}
                                                                                                <Tooltip title="Edit">
                                                                                                    <img src={homepage+"/assets/images/icons/edit.png"} alt="edit" className="pl-2" onClick={() => this.showModal(item2)} />
                                                                                                </Tooltip>
                                                                                                <Switch className='ml-2' checked={parseInt(item2.config_statuss)} onChange={(status) => this.switchChange(status, item2.id, index)} />
                                                                                            </div>
                                                                                            :
                                                                                            <Switch checked={parseInt(item2.config_statuss)} onChange={(status) => this.switchChange(status, item2.id, index)} />
                                                                                    }
                                                                                    {item2.config_name === 'Auto TG Counselling Station' &&
                                                                                        <div className='col-5'>
                                                                                            <Select
                                                                                                showSearch
                                                                                                mode="single"
                                                                                                style={{ width: '100%' }}
                                                                                                filterOption={false}
                                                                                                value={item2.auto_counselling_station ? item2.auto_counselling_station : ''}
                                                                                                placeholder="Select Counselling Station"
                                                                                                onChange={this.patientDetails.bind(this, item2.id)}
                                                                                            >
                                                                                                {stationList.map((data, key) => {
                                                                                                    return (<Option key={key} value={data.id}>{data.name}</Option>)
                                                                                                })}
                                                                                            </Select>
                                                                                        </div>
                                                                                    }
                                                                                </div>
                                                                            )
                                                                        } else if (item2.config_type === 'queue') {
                                                                            return (
                                                                                <div key={index} className="group-td">
                                                                                    {
                                                                                        item2.bill_tracking_percent
                                                                                            ? <div>
                                                                                                {(item2.bill_tracking_percent !== null) ? item2.bill_tracking_percent : '--'} {(item2.config_name === 'Print Waiting Time') ? 'Min' : '%'}
                                                                                                <Tooltip title="Edit">
                                                                                                    <img src={homepage+"/assets/images/icons/edit.png"} alt="edit" className="pl-2" onClick={() => this.showModal(item2)} />
                                                                                                </Tooltip>
                                                                                            </div>
                                                                                            :
                                                                                            <Switch checked={parseInt(item2.config_statuss)} onChange={(status) => this.switchChange(status, item2.id, index)} />
                                                                                    }
                                                                                </div>
                                                                            )
                                                                        }
                                                                        else {
                                                                            return (
                                                                                <div key={index} className="group-td" style={{ height: '100%' }}>
                                                                                    {
                                                                                        item2.bill_tracking_percent
                                                                                            ? <div>
                                                                                                {(item2.bill_tracking_percent !== null) ? item2.bill_tracking_percent : '--'} {(item2.config_name !== 'Ins-Physician Fees ICU' && item2.config_name !== 'Ins-Physician Fees Room') && '%'}
                                                                                                <Tooltip title="Edit">
                                                                                                    <img src={homepage+"/assets/images/icons/edit.png"} alt="edit" className="pl-2" onClick={() => this.showModal(item2)} />
                                                                                                </Tooltip>
                                                                                            </div>
                                                                                            :
                                                                                            <Switch checked={parseInt(item2.config_statuss)} onChange={(status) => this.switchChange(status, item2.id, index)} />
                                                                                    }
                                                                                </div>
                                                                            )
                                                                        }

                                                                    }
                                                                })
                                                        }
                                                    </td>
                                                    <td className="p-0">
                                                        {item.data.map((item, index) => {
                                                            console.log('UPDATEEDAT', item)
                                                            if (item.config_name === 'Email') {
                                                                return (
                                                                    <div key={index} className="group-td" style={{ height: item.config_name == 'Email' ? item.emailList.length > 0 ? ((item.emailList.length * 10) + 11) + 'px' : '100%' : '100%' }}>
                                                                        {item.updated_at ? moment(item.updated_at).format('DD MMM YYYY') : '--'}
                                                                    </div>
                                                                )
                                                            } else {
                                                                if (item.config_type === 'trackbills') {
                                                                    return (
                                                                        <div key={index} className="group-td">
                                                                            {item.updated_at ? moment(item.updated_at).format('DD MMM YYYY') : '--'}
                                                                        </div>
                                                                    )
                                                                } else if (item.config_type === 'queue') {
                                                                    if (item.config_name === 'ICU Tagged Departments') {
                                                                        return (
                                                                            <div key={index} className="group-td" style={{ height: item.config_name == 'ICU Tagged Departments' ? item.include_departments.length > 0 ? ((item.include_departments.length * 10) + 11) + 'px' : '100%' : '100%' }}>
                                                                                {item.updated_at ? moment(item.updated_at).format('DD MMM YYYY') : '--'}
                                                                            </div>
                                                                        )
                                                                    }
                                                                     else {
                                                                        return (
                                                                            <div key={index} className="group-td">
                                                                                {item.updated_at ? moment(item.updated_at).format('DD MMM YYYY') : '--'}
                                                                            </div>
                                                                        )
                                                                    }
                                                                    
                                                                } 
                                                                else {
                                                                    return (
                                                                        // <div key={index} className="group-td" style={{height:item.text&&(item.text).trim().length> 111?'62px':'100%'}} >
                                                                        //     {item.updated_at ? moment(item.updated_at).format('DD MMM YYYY') : '--'}
                                                                        // </div>
                                                                           <div key={index} className="group-td" 
                                                                           style={{
                                                                            height: 
                                                                                (item.dept_cd && item.dept_cd.trim().length > 20) ? '63px' :
                                                                                (item.description && item.description.trim().length > 104) ? '84px' :
                                                                                '64%'
                                                                        }}>
                                                                               {item.updated_at ? moment(item.updated_at).format('DD MMM YYYY') : '--'}
                                                                           </div>
                                                                    )
                                                                }

                                                            }         

                                                        })}

                                                    </td>
                                                </tr>
                                                )
                                            }
                                            )}
                                        </tbody>
                                        :
                                        <tbody>
                                            <tr>
                                                <td colSpan="13" className="text-center">
                                                    <img src={homepage+"/assets/images/icons/no-data.svg"} alt="" />
                                                    <p className="no-data mb-0">No Data</p>
                                                </td>
                                            </tr>
                                        </tbody>
                                }

                            </table>
                            <Modal visible={this.state.visible} onCancel={this.handleCancel} destroyOnClose={true} footer={null} maskClosable={false}>
                                <div className="p-5">
                                    <h3 className="text-center text-capitalize" style={{ 'fontfamily': 'normal' }}>update {title}</h3>
                                    <div className="row pt-4 justify-content-center">
                                        {(formData !== undefined) && <React.Fragment>

                                            {formData
                                                .map((feild, key) => {

                                                    if (feild.element === 'input') {
                                                        return (
                                                            <div
                                                                className={`col-12 my-2 ${feild.name}`}
                                                                key={key}>
                                                                <div className="clearfix">
                                                                    <p className="data-label w-100 mb-1">{title}{(title !== 'Ins-Physician Fees ICU' && title !== 'Ins-Physician Fees Room') ? '(%)*' : '(Times)'}</p>
                                                                </div>
                                                                <Inputlayer
                                                                    {...this.props}
                                                                    {...this.state}
                                                                    feildData={feild}
                                                                    onInputChanges={this
                                                                        .handleChange
                                                                        .bind(this)}
                                                                />
                                                            </div>
                                                        )
                                                    }
                                                })
                                            }
                                        </React.Fragment>}
                                        <div className="row justify-content-center pt-4">
                                            <button className="btn btn-success text-capitalize mr-3" onClick={this.updateBilltracking} loading={this.state.btnloading}>update</button>
                                            <button className="btn btn-next text-capitalize" onClick={this.handleCancel} loading={this.state.btnloading}>cancel</button>
                                        </div>
                                    </div>


                                </div>
                            </Modal>
                            <Modal visible={smsmodal} onCancel={this.smshandleCancel} destroyOnClose={true} footer={null} maskClosable={false}>
                                <div className="p-5">
                                    <h5 className="text-center text-capitalize" style={{ 'fontfamily': 'normal' }}>SMS Exclude Departments</h5>
                                    <div className="row pt-4 justify-content-center">
                                        {(smsformData !== undefined) && <React.Fragment>

                                            {smsformData
                                                .map((feild, key) => {

                                                    if (feild.element === 'select2multiple' && feild.visible) {
                                                        return (
                                                            <React.Fragment key={key}>
                                                                <div
                                                                    className={`${feild.className
                                                                        ? feild.className
                                                                        : 'col '} ${feild.name}`}
                                                                    key={key}>
                                                                    <Select2multiple
                                                                        Queuedata={formData}
                                                                        selectdata={feild}
                                                                        {...this.props}
                                                                        {...this.state}
                                                                        onselectChanges={this
                                                                            .handleChange
                                                                            .bind(this, feild)}
                                                                    /> {feild
                                                                        .errors
                                                                        .map((error, eKey) => {
                                                                            return (
                                                                                <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                                            );
                                                                        })}
                                                                </div>
                                                            </React.Fragment>
                                                        )
                                                    }
                                                })
                                            }
                                        </React.Fragment>}
                                    </div>
                                    <div className="row justify-content-center pt-4">
                                        <button className="btn btn-success text-capitalize mr-3" onClick={this.updatesms} loading={this.state.btnloading}>update</button>
                                        <button className="btn btn-next text-capitalize" onClick={this.smshandleCancel} loading={this.state.btnloading}>cancel</button>
                                    </div>

                                </div>
                            </Modal>
                            <Modal visible={icumodal} onCancel={this.icuhandleCancel} destroyOnClose={true} footer={null} maskClosable={false}>
                                <div className="p-5">
                                    <h5 className="text-center text-capitalize" style={{ 'fontfamily': 'normal' }}>ICU Tagged Departments</h5>
                                    <div className="row pt-4 justify-content-center">
                                        {(icuformData !== undefined) && <React.Fragment>

                                            {icuformData
                                                .map((feild, key) => {

                                                    if (feild.element === 'select2multiple' && feild.visible) {
                                                        return (
                                                            <React.Fragment key={key}>
                                                                <div
                                                                    className={`${feild.className
                                                                        ? feild.className
                                                                        : 'col '} ${feild.name}`}
                                                                    key={key}>
                                                                    <Select2multiple
                                                                        Queuedata={formData}
                                                                        selectdata={feild}
                                                                        {...this.props}
                                                                        {...this.state}
                                                                        onselectChanges={this
                                                                            .handleChange
                                                                            .bind(this, feild)}
                                                                    /> {feild
                                                                        .errors
                                                                        .map((error, eKey) => {
                                                                            return (
                                                                                <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                                            );
                                                                        })}
                                                                </div>
                                                            </React.Fragment>
                                                        )
                                                    }
                                                })
                                            }
                                        </React.Fragment>}
                                    </div>
                                    <div className="row justify-content-center pt-4">
                                        <button className="btn btn-success text-capitalize mr-3" onClick={this.updateICU} loading={this.state.btnloading}>update</button>
                                        <button className="btn btn-next text-capitalize" onClick={this.icuhandleCancel} loading={this.state.btnloading}>cancel</button>
                                    </div>

                                </div>
                            </Modal>
                            <Modal visible={checklistmodal} onCancel={this.checkListAddHandleCancel} destroyOnClose={true} footer={null} maskClosable={false}>
                                <div className="p-5">
                                    <h3 className="text-center text-capitalize" style={{ 'fontfamily': 'normal' }}>Add CheckList</h3>

                                    <div className="row pt-4 justify-content-center">


                                        {(checklistaddformData !== undefined) && <React.Fragment>
                                            {checklistaddformData
                                                .map((feild, key) => {
                                                    if (feild.element === 'input' && feild.visible) {
                                                        return (
                                                            <React.Fragment key={key}>
                                                                <div
                                                                    className={`col-12 my-2 ${feild.name}`}
                                                                    key={key}>
                                                                    <div className="clearfix">
                                                                        <p className="data-label w-100 mb-1">Key Point</p>
                                                                    </div>
                                                                    <textarea placeholder="Add CheckList" autoFocus='true' className="textarea" style={{ height: '90px' }} 
                                        value={textValue ? textValue : ''} 
                                        onChange={(event) => this.handleChangeTextarea(event)}></textarea>
                                                                    {/* <Inputlayer {...this.props} {...this.state}
                                                                        feildData={feild}
                                                                        onInputChanges={this.handleChange.bind(this)} /> */}
                                                                </div>
                                                            </React.Fragment>
                                                        )
                                                    }
                                                })
                                            }
                                        </React.Fragment>}
                                        <div className="row justify-content-center pt-4">
                                            <button className="btn btn-success text-capitalize mr-3" onClick={this.addCheckList} loading={this.state.btnloading}>save</button>
                                            <button className="btn btn-next text-capitalize" onClick={this.checkListAddHandleCancel} loading={this.state.btnloading}>cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </Modal>
                            <Modal visible={nmelistmodal} onCancel={this.checkListAddHandleCancel} destroyOnClose={true} footer={null} maskClosable={false}>
                            <div className="p-5">
                                    <h3 className="text-center text-capitalize" style={{ 'fontfamily': 'normal' }}>Add NME Points</h3>
                                    <div className="row pt-4 justify-content-center">
                                        {(nmelistaddformData !== undefined) && (
                                            <React.Fragment>
                                            {nmelistaddformData.map((feild, key) => {
                                                console.log('feildfeild', feild);
                                                if (feild.element === 'select2') {
                                                    return (
                                                        <React.Fragment key={key}>
                                                            <div
                                                                style={{width:'90%', marginBottom:'2%',marginTop:'4%'}}
                                                                className={`col-12  ${feild.name}`}
                                                                key={key}>
                                                                <Select2
                                                                    Queuedata={formData}
                                                                    selectdata={feild}
                                                                    {...this.props}
                                                                    {...this.state}
                                                                    onselectChanges={this
                                                                        .handleChange
                                                                        .bind(this)}
                                                                /> 
                                                                {feild
                                                                    .errors
                                                                    .map((error, eKey) => {
                                                                        return (
                                                                            <small key={eKey} className="form-text text-danger" >{error.message}</small>
                                                                        );
                                                                    })}
                                                            </div>
                                                        </React.Fragment>
                                                    )
                                                }
                                                if (feild.element === 'select2multiple' && feild.visible) {
                                                    return (
                                                        <React.Fragment key={key}>
                                                            <div
                                                                className={`${feild.className
                                                                    ? feild.className
                                                                    : 'col '} ${feild.name}`}
                                                                key={key}>
                                                                    <div style={{width:'324px', marginLeft: '-117px',marginTop:'15%'}}>
                                                                <Select2multiple                                   
                                                                    Queuedata={formData}
                                                                    selectdata={feild}
                                                                    {...this.props}
                                                                    {...this.state}
                                                                    onselectChanges={this
                                                                        .handleChange
                                                                        .bind(this, feild)}
                                                                />
                                                                </div>
                                                                {feild
                                                                    .errors
                                                                    .map((error, eKey) => {
                                                                        return (
                                                                            <small key={eKey} className="form-text text-danger" style={{marginLeft:'-97%'}}>{error.message}</small>
                                                                        );
                                                                    })}
                                                            </div>
                                                        </React.Fragment>
                                                    )
                                                }
                                                    if (feild.element === 'input' && feild.visible) {
                                                        return (
                                                            <React.Fragment key={key}>
                                                                <div
                                                                    className={`col-12 my-2 ${feild.name}`}
                                                                    key={key}>
                                                                    <div className="clearfix" style={{marginTop:'2%'}}>
                                                                    </div>
                                                                    <textarea placeholder="Add Description" autoFocus='true' className="textarea" style={{ height: '90px', width:'98%', marginLeft:'1%', marginTop:'4%'}} 
                                                                        value={descriptionValue ? descriptionValue  : ''} 
                                                                        onChange={(event) => this.handleChangeNmeTextarea(event)}>
                                                                    </textarea>
                                                                    {feild
                                                                    .errors
                                                                    .map((error, eKey) => {
                                                                        return (
                                                                            <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                                        );
                                                                    })}
                                                                </div>
                                                            </React.Fragment>
                                                        )
                                                    }
                                                    if (feild.element === 'input') {
                                                        return (
                                                            <div
                                                            style={{width:'90%', marginTop:'4%'}}
                                                            key={key}>
                                                           
                                                                    <Inputlayer {...this.props} {...this.state} feildData={feild} onInputChanges={this.handleChange.bind(this)} />
                                                                </div>
                                                        )
                                                    }      
                                            })}
                                            </React.Fragment>
                                        )}
                                        <div className="row justify-content-center pt-4" style={{marginBottom: '-50px'}}>
                                            <button style={{marginTop: '25px'}} className="btn btn-success text-capitalize mr-3" onClick={this.addNmeList} loading={this.state.btnloading}>save</button>
                                            <button style={{marginTop: '25px'}} className="btn btn-next text-capitalize" onClick={this.nmeListAddHandleCancel} loading={this.state.btnloading}>cancel</button>
                                        </div>
                                        {/* <div className='input-group-append mt-3' style={{marginBottom: '-60px'}}>
                                            <button style={{marginTop: '110px'}} className='btn btn-primary btn-sm' onClick={this.addEmails}>Add</button>
                                            <button className="btn btn-next text-capitalize" onClick={this.checkListAddHandleCancel} loading={this.state.btnloading}>cancel</button>
                                        </div> */}
                                    </div>
                                </div>
                            </Modal>
                            <Modal visible={emailmodal} onCancel={this.emailhandleCancel} destroyOnClose={true} footer={null} maskClosable={false} width='600px'>
                                <div className="p-0">
                                    <h5 className="text-center text-capitalize" style={{ 'fontfamily': 'normal' }}>Email Id`s</h5>
                                    <div className="row pt-4 justify-content-center">
                                        {(emailformData !== undefined) && <React.Fragment>
                                            {emailformData
                                                .map((feild, key) => {
                                                    if (feild.element === 'input' && feild.visible) {
                                                        return (
                                                            <React.Fragment key={key}>
                                                                <div className={`${feild.className ? feild.className : 'col '} ${feild.name}`} key={key}>
                                                                    <div class="input-group justify-content-center">
                                                                        <Inputlayer {...this.props} {...this.state}
                                                                            feildData={feild}
                                                                            onInputChanges={this.handleChange.bind(this)} />

                                                                    </div>
                                                                    {/* {feild.errors.map((error, eKey) => {return (<small key={eKey} className="form-text text-danger">{error.message}</small>);})} */}
                                                                </div>
                                                            </React.Fragment>
                                                        )
                                                    }
                                                    if (feild.element === 'select2multiple' && feild.visible) {
                                                        return (
                                                            <React.Fragment key={key}>
                                                                <div
                                                                    className={`${feild.className
                                                                        ? feild.className
                                                                        : 'col '} ${feild.name}`}
                                                                    key={key}>
                                                                    <Select2multiple
                                                                        Queuedata={formData}
                                                                        selectdata={feild}
                                                                        {...this.props}
                                                                        {...this.state}
                                                                        onselectChanges={this
                                                                            .handleChange
                                                                            .bind(this, feild)}
                                                                    />

                                                                    {feild
                                                                        .errors
                                                                        .map((error, eKey) => {
                                                                            return (
                                                                                <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                                            );
                                                                        })}
                                                                </div>
                                                            </React.Fragment>
                                                        )
                                                    }
                                                })
                                            }
                                        </React.Fragment>}

                                        <div className='input-group-append mt-3'>
                                            <button className='btn btn-primary btn-sm' onClick={this.addEmails}>Add</button>
                                        </div>
                                    </div>
                                    <div className="justify-content-center pt-4">
                                        <table class="table" style={{ background: "white" }}>
                                            <thead>
                                                <tr>
                                                    <td scope="col">#</td>
                                                    <td scope="col">Email Id</td>
                                                    <td scope="col">Units</td>
                                                    <td scope="col">Action</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {emailList && emailList.length ? emailList.map((data, key) =>
                                                    // <div className='row'><li key={key}>{data.email_name}</li><DeleteOutlined onClick={()=>this.deleteMailID(data.id)}/></div>
                                                    <tr>
                                                        <td scope="row" className='p-1 text-center'>{key + 1}</td>
                                                        <td className='p-1'>{data.email_id}</td>
                                                        <td> {(data['mapping_units'] && data['mapping_units'].length > 0) ?
                                                            <React.Fragment>
                                                                {(data['mapping_units']).map((unit, key) => {
                                                                    return (<div key={key}><p className='p-0 m-0'>{unit['unitname']}{data['mapping_units'].length === key + 1 ? '' : ' ,'}</p></div>)
                                                                })
                                                                }
                                                            </React.Fragment>
                                                            : '--'}
                                                        </td>
                                                        {/* <td><DeleteOutlined style={{color:"red"}} onClick={()=>this.deleteMailID(data.id)}/></td> */}
                                                        <td className='p-1 text-center'>
                                                            <Popconfirm
                                                                title="Delete the Email Id"
                                                                description="Are you sure to delete this Id?"
                                                                icon={
                                                                    <QuestionCircleOutlined
                                                                        style={{
                                                                            color: 'red',
                                                                        }}
                                                                    />
                                                                }
                                                                onConfirm={() => this.deleteMailID(data.id)}
                                                                onCancel={() => this.setState({ popUpVisible: true })}
                                                            >
                                                                <DeleteOutlined style={{ color: "red" }} onClick={() => this.setState({ popUpVisible: true })} />
                                                            </Popconfirm>
                                                        </td>
                                                    </tr>
                                                ) : ""}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="row justify-content-center pt-4">
                                        <button className="btn btn-next text-capitalize" onClick={this.emailhandleCancel} loading={this.state.btnloading}>cancel</button>
                                    </div>
                                </div>
                            </Modal>
                            <Modal visible={breakModalVisible} onCancel={this.breakshandleCancel} destroyOnClose={true} footer={null} maskClosable={false} width={"40%"}>
                                <div className="p-0">
                                    <h3 className="text-center text-capitalize" style={{ 'fontfamily': 'normal' }}>Update {breaksDetails && breaksDetails.reason}</h3>
                                    <div className="row justify-content-center">
                                        {(breaksformData) && <React.Fragment>
                                            {breaksformData.map((feild, key) => {
                                                if (feild.element === 'input') {
                                                    return (
                                                        <div
                                                            className={`col-9 d-flex my-3 ${feild.name}`}
                                                            key={key}
                                                        >
                                                            <div className="col-4">
                                                                <p className="data-label w-100 mb-1">{feild.title}</p>
                                                            </div>
                                                            {/* <Input value={feild.value} suffix={feild.suffix} onChange={this.handleChange.bind(this, feild)}/>
                                                            {feild.errors && feild.errors.map((error, eKey) => <small key={eKey} className="form-text text-danger">{error.message}</small>)} */}
                                                            {/* <Inputlayer {...this.props} {...this.state} feildData={feild} onInputChanges={this.handleChange.bind(this)} /> */}
                                                            <div class="col-6 input-group justify-content-center">
                                                                <Inputlayer {...this.props} {...this.state} feildData={feild} onInputChanges={this.handleChange.bind(this)} />
                                                            </div>
                                                            <label>{feild.suffix}</label>
                                                        </div>
                                                    )
                                                }
                                            })}
                                        </React.Fragment>}
                                        <div className="row justify-content-center pt-4">
                                            <button className="btn btn-success text-capitalize mr-3" onClick={() => this.updateBreakTimeandBreakCount()} loading={this.state.btnloading}>update</button>
                                            <button className="btn btn-next text-capitalize" onClick={this.breakshandleCancel} loading={this.state.btnloading}>cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </Modal>

                            <Modal visible={checkModalVisible} onCancel={this.checklisthandleCancel} destroyOnClose={true} footer={null} maskClosable={false} width={"40%"}>
                                <div className="p-0">
                                    <h3 className="text-center text-capitalize" style={{ 'fontfamily': 'normal' }}>Update CheckList</h3>
                                    <div className="row justify-content-center">
                                        {(checklistformData) && <React.Fragment>
                                            {checklistformData.map((feild, key) => {
                                                if (feild.element === 'input') {
                                                    return (
                                                        <div
                                                            className={`col-9 d-flex my-3 ${feild.name}`}
                                                            key={key}
                                                        >
                                                            {/* <div className="col-2">
                                                                <p className="data-label w-100 mb-1">{feild.title}</p>
                                                            </div> */}
                                                          
                                                            <div class="col-10 input-group justify-content-center">
                                                            <p className="data-label w-100 mb-1">Key Point</p>
                                        <textarea placeholder="Add CheckList" autoFocus='true' className="textarea" style={{ height: '90px' }} 
                                        value={textValue ? textValue : ''} 
                                        onChange={(event) => this.handleChangeTextarea(event)}></textarea>
                                                                {/* <Inputlayer {...this.props} {...this.state} feildData={feild} onInputChanges={this.handleChange.bind(this)} /> */}
                                                            </div>

                                                        </div>
                                                    )
                                                }
                                            })}
                                        </React.Fragment>}
                                        <div className="row justify-content-center pt-4">
                                            <button className="btn btn-success text-capitalize mr-3" onClick={() => this.updateCheckList()} loading={this.state.btnloading}>update</button>
                                            <button className="btn btn-next text-capitalize" onClick={this.checklisthandleCancel} loading={this.state.btnloading}>cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </Modal>
                            <Modal visible={nmeModalVisible} onCancel={this.nmelisthandleCancel} destroyOnClose={true} footer={null} maskClosable={false} width={"40%"}>
                                <div className="p-0">
                                    <h3 className="text-center text-capitalize" style={{ 'fontfamily': 'normal' }}>Update NME List</h3>
                                    <div className="row pt-4 justify-content-center">
                                        {(nmelistformData!== undefined) && (
                                            <React.Fragment>
                                            {nmelistformData.map((feild, key) => {
                                                if (feild.element === 'select2') {
                                                    return (
                                                        <React.Fragment key={key}>
                                                            <div
                                                                style={{width:'56%', marginBottom:'2%'}}
                                                                key={key}>
                                                                <Select2
                                                                    Queuedata={formData}
                                                                    selectdata={feild}
                                                                    {...this.props}
                                                                    {...this.state}
                                                                    onselectChanges={this
                                                                        .handleChange
                                                                        .bind(this)}
                                                                /> 
                                                                
                                                            </div>
                                                        </React.Fragment>
                                                    )
                                                }
                                                    if (feild.element === 'input' && feild.visible) {
                                                        return (
                                                            <React.Fragment key={key}>
                                                                <div
                                                                    className={`col-12 my-2 ${feild.name}`}
                                                                    key={key}>
                                                                    <div className="clearfix">
                                                                    </div>
                                                                    <textarea placeholder="Add Description" autoFocus='true' className="textarea" style={{ height: '90px', width:'60%', marginLeft:'20%', marginTop:'-2%'}} 
                                                                        value={descriptionValue ? descriptionValue : ''} 
                                                                        onChange={(event) => this.handleChangeNmeTextarea(event)}>
                                                                    </textarea>
                                                                </div>
                                                            </React.Fragment>
                                                        )
                                                    }
                                                    if (feild.element === 'input') {
                                                        return (
                                                            <div
                                                            style={{width:'56%', marginTop:'-2%'}}
                                                            key={key}>
                                                           
                                                                    <Inputlayer {...this.props} {...this.state} feildData={feild} onInputChanges={this.handleChange.bind(this)} />
                                                                </div>
                                                        )
                                                    }      
                                            })}
                                            </React.Fragment>
                                        )}
                                        <div className="row justify-content-center pt-4">
                                            <button style={{marginTop: '25px'}} className="btn btn-success text-capitalize mr-3" onClick={() => this.updatenmeList()} loading={this.state.btnloading}>update</button>
                                            <button style={{marginTop: '25px'}} className="btn btn-next text-capitalize" onClick={this.nmelisthandleCancel} loading={this.state.btnloading}>cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </Modal>
                        </div>
                    </Spin>
                </div>
                <div style={{ marginLeft: '86%' }}>
                    {showAddButton && (
                        <button className="btn btn-success text-capitalize px-5 mx-2" onClick={this.showAddCheckList}>Add</button>
                    )}
                </div>
                <div style={{ marginLeft: '86%' }}>
                    {showAddButton2 && (
                        <button className="btn btn-success text-capitalize px-5 mx-2" onClick={this.showAddNmeList}>Add</button>
                    )}
                </div>
            </div>

        )
    }
}

export default Configuration;